! function () {
    "use strict";

    function e(t, i, n) {
        for (var a in i) "function" == typeof i[a] ? t.addEventListener(n + a, i[a]) : Object(i[a]) === i[a] ? e(t, i[a], n + a + "-") : t.setAttribute(n + a, i[a])
    }

    function t(t) {
        var i = t instanceof Node ? t : document.createElement(t);
        return [].slice.call(arguments, 1).forEach(function (t) {
            t instanceof Node ? i.appendChild(t) : "string" == typeof t ? i.appendChild(document.createTextNode(t)) : e(i, t, "")
        }), i
    }

    function i(e, t, i) {
        var n = document.createEvent("CustomEvent");
        n.initCustomEvent(t, !0, !0, i), e.dispatchEvent(n)
    }

    function n(e) {
        var t = void 0,
            i = [];
        e.addEventListener("blur", function () {
            i.forEach(function (e) {
                e.removeAttribute("js-focus"), e.removeAttribute("js-focus-ring")
            })
        }, !0), e.addEventListener("focus", function () {
            var e = document.activeElement;
            e instanceof Element && (e.setAttribute("js-focus", ""), t && e.setAttribute("js-focus-ring", ""), i.push(e))
        }, !0), e.addEventListener("keydown", function () {
            t = clearTimeout(t) || setTimeout(function () {
                t = 0
            }, 100)
        }, !0)
    }
    var a = function () {
        Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector), Element.prototype.closest || (Element.prototype.closest = function (e) {
            var t = this,
                i = this;
            if (!document.documentElement.contains(t)) return null;
            do {
                if (i.matches(e)) return i;
                i = i.parentElement
            } while (null !== i);
            return null
        }), document.addEventListener("click", function (e) {
            var t = e.target.closest("a, [data-onclick-for]");
            if (t) {
                var i = t.ownerDocument.getElementById(t.getAttribute("data-onclick-for"));
                i && i.click()
            }
        })
    },
        r = function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
        },
        s = function () {
            function e(e, t) {
                for (var i = 0; i < t.length; i++) {
                    var n = t[i];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n)
                }
            }
            return function (t, i, n) {
                return i && e(t.prototype, i), n && e(t, n), t
            }
        }(),
        o = function () {
            function e(t, i) {
                function n() {
                    clearTimeout(h), h = setTimeout(u, 0, event)
                }
                var a = this;
                r(this, e);
                var s = Object(i);
                for (var o in e.defaults) this[o] = o in s ? s[o] : e.defaults[o];
                var l = this.target = t instanceof Element ? t : document.querySelector(t);
                l.classList.add(this.prefix), l.id = l.id || this.prefix;
                var c = function (e, t) {
                    var i = a[e + "Control"] = document.createElement("button");
                    i.className = a.prefix + "-immediate-control " + a.prefix + "-" + e + "-control", i.addEventListener("click", function () {
                        a.setSlideByIndex(a.currentIndex + t)
                    }), i.appendChild(document.createElement("span")).appendChild(document.createTextNode(a.lang[e] + " " + a.lang.slide))
                };
                c("previous", -1), c("next", 1), l.insertBefore(this.previousControl, l.firstElementChild), l.appendChild(this.nextControl);
                var d = this.paginationControls = document.createElement("nav");
                d.className = this.prefix + "-pagination-controls", d.setAttribute("role", "navigation"), d.setAttribute("aria-labelledby", l.id), l.appendChild(d), this.paginationControl = [], this.slides = [].map.call(Object(this.slides) === this.slides && "number" == typeof this.slides.length ? this.slides : l.querySelectorAll(this.slides), function (e, t) {
                    e.id = e.id || a.prefix + "-slide-" + t, e.classList.add(a.prefix + "-slide"), e.classList.add(a.prefix + "-slide-" + t), e.classList.add(a.prefix + "-inactive-slide"), e.setAttribute("aria-hidden", !0);
                    var i = a.paginationControl[t] = d.appendChild(document.createElement("button"));
                    return i.className = a.prefix + "-pagination-control " + a.prefix + "-inactive-control", i.addEventListener("click", function () {
                        a.setSlideByIndex(t)
                    }), i.appendChild(document.createElement("span")).appendChild(document.createTextNode(a.lang.slide + " " + (t + 1))), {
                            target: e,
                            control: i
                        }
                }), this.isVisible = !0, this.isMouseInteractive = !1, this.isFocusInteractive = !1, this.isInputInteractive = !1;
                var u = function (e) {
                    var t = "visibilitychange" === e.type ? "visible" === l.ownerDocument.visibilityState : a.isVisible,
                        i = "mouseenter" === e.type || "mouseleave" !== e.type && a.isMouseInteractive,
                        n = "focusin" === e.type || "focusout" !== e.type && a.isFocusInteractive,
                        r = i || n;
                    t !== a.isVisible && (a.isVisible = t, a.autoplay && a[t ? "play" : "pause"](), a.dispatch(t ? "visibilityvisible" : "visibilityhidden", e.target), a.dispatch("visibilitychange", e.target)), i !== a.isMouseInteractive && (a.isMouseInteractive = i, a.dispatch(i ? "mouseenter" : "mouseleave", e.target), a.dispatch("mousechange", e.target)), n !== a.isFocusInteractive && (a.isFocusInteractive = n, a.autoplay && a[n ? "pause" : "play"](), a.dispatch(n ? "focusenter" : "focusleave", e.target), a.dispatch("focuschange", e.target)), r !== a.isInputInteractive && (a.isInputInteractive = r, a.dispatch(r ? "inputenter" : "inputleave", e.target), a.dispatch("inputchange", e.target))
                };
                l.ownerDocument.addEventListener("visibilitychange", u), l.addEventListener("mouseenter", u), l.addEventListener("mouseleave", u), l.addEventListener("focusout", n), l.addEventListener("focusin", n);
                var h = void 0,
                    m = this.currentIndex || 0;
                this.currentIndex = null, this.setSlideByIndex(m), this.dispatch("loaded", l), this.autoplay && this.play()
            }
            return s(e, [{
                key: "setSlideByIndex",
                value: function (e) {
                    if (this.currentIndex !== e) {
                        var t = this.slides.length,
                            i = this.lastIndex = this.currentIndex,
                            n = this.currentIndex = (t + e % t) % t,
                            a = this.slides[i],
                            r = this.slides[n];
                        a && (a.target.classList.remove(this.prefix + "-active-slide"), a.target.classList.add(this.prefix + "-inactive-slide"), a.target.setAttribute("aria-hidden", !0), a.control.classList.remove(this.prefix + "-active-control"), a.control.classList.add(this.prefix + "-inactive-control"), a.control.removeAttribute("aria-current"), a.control.removeAttribute("aria-controls"), this.dispatch("slideleave", a.target)), r.target.classList.add(this.prefix + "-active-slide"), r.target.classList.remove(this.prefix + "-inactive-slide"), r.target.removeAttribute("aria-hidden"), r.control.classList.add(this.prefix + "-active-control"), r.control.classList.remove(this.prefix + "-inactive-control"), r.control.setAttribute("aria-current", !0), r.control.setAttribute("aria-controls", r.target.id), this.dispatch("slideenter", r.target), this.dispatch("slidechange", r.target)
                    }
                }
            }, {
                key: "dispatch",
                value: function (e, t) {
                    var i = document.createEvent("CustomEvent");
                    i.initCustomEvent(this.prefix + ":" + e, !0, !1, this), t.dispatchEvent(i)
                }
            }, {
                key: "play",
                value: function () {
                    var e = this;
                    this._interval || (! function t() {
                        var i = e.slides[e.currentIndex].duration || e.duration;
                        e._interval = setTimeout(function () {
                            e.setSlideByIndex(e.currentIndex + 1), e._interval && (e._interval = clearTimeout(e._interval), t())
                        }, i)
                    }(), this.dispatch("play", this.target), this.dispatch("playpause", this.target))
                }
            }, {
                key: "pause",
                value: function () {
                    this._interval && (this._interval = clearTimeout(this._interval), this.dispatch("pause", this.target), this.dispatch("playpause", this.target))
                }
            }]), e
        }();
    o.defaults = {
        prefix: "carousel",
        slides: "li",
        currentIndex: 0,
        duration: 8e3,
        autoplay: !1,
        lang: {
            next: "Next",
            previous: "Previous",
            slide: "Slide"
        }
    };
    var l = function () {
        [].forEach.call(document.querySelectorAll(".n-gallery"), function (e) {
            new o(e, {
                prefix: "n-gallery"
            })
        })
    },
        c = [.47, 0, .745, .715],
        d = 400,
        u = function (e) {
            return ! function t() {
                /m/.test(document.readyState) ? (document.removeEventListener("readystatechange", t), e()) : document.addEventListener("readystatechange", t)
            }()
        },
        h = function () {
            [].forEach.call(document.querySelectorAll(".n-gateway-carousel"), function (e) {
                function t(t) {
                    var i = t.detail,
                        n = i.slides[i.currentIndex],
                        a = n.target.getAttribute("data-theme"),
                        r = n.target.getAttribute("data-image-url");
                    e.setAttribute("data-theme", a), e.style.backgroundImage = "url(" + r + ")", u(function () { }), n.target.animate({
                        opacity: [0, 1],
                        transform: ["translate(0,50px)", "translate(0,0)"]
                    }, {
                            duration: d,
                            easing: "cubic-bezier(" + c + ")"
                        })
                }
                e.addEventListener("n-gateway-carousel:loaded", function (e) {
                    var t = e.detail;
                    t.paginationControls.setAttribute("data-items", t.slides.length), t.slides.forEach(function (e) {
                        var t = e.target.getAttribute("data-thumbnail-url");
                        e.control.style.backgroundImage = "url(" + t + ")"
                    })
                }), e.addEventListener("n-gateway-carousel:loaded", t), e.addEventListener("n-gateway-carousel:slideenter", t), new o(e, {
                    prefix: "n-gateway-carousel",
                    slides: ".n-gateway-carousel-article",
                    duration: 5e3
                })
            })
        },
        m = function (e) {
            function n(n) {
                var isArcGis = location.pathname.indexOf('arcgis-blog') > -1 ? true : false;
                if (isArcGis) {
                    return;
                }

                n && "reset" === n.type && (s.value = "");
                var a = s.value;
                a !== m && (m = a, i(u, e.prefix + ":input", {
                    value: m,
                    event: n
                })), h && !a ? (h = !1, r.removeAttribute("data-filled"), d.removeAttribute("data-filled")) : !h && a && (h = !0, t(r, {
                    data: {
                        filled: ""
                    }
                }), t(d, {
                    data: {
                        filled: ""
                    }
                })), o.nodeValue = a;
                var p = l.scrollWidth + "px";
                c.style.width = p
            }

            function a(t) {
                i(u, e.prefix + ":submit", {
                    value: s.value,
                    event: t
                })
            }
            var r = t("label", {
                class: e.prefix + "-label",
                for: e.prefix + "-query-control"
            }, e.queryLabel),
                s = t("input", {
                    class: e.prefix + "-control",
                    id: e.prefix + "-control",
                    type: "search",
                    name: "q",
                    autocapitalize: "off",
                    autocomplete: "off",
                    autocorrect: "off",
                    spellcheck: "false"
                }),
                o = document.createTextNode(""),
                l = t("div", {
                    class: e.prefix + "-measure-text",
                    aria: {
                        hidden: !0
                    }
                }, o),
                c = t("div", {
                    class: e.prefix + "-measure"
                }, l),
                d = t("button", {
                    class: e.prefix + "-submit",
                    type: "submit",
                    aria: {
                        label: e.submitLabel
                    }
                }),
                u = t("form", {
                    class: e.prefix + "-form",
                    action: e.action,
                    role: "search",
                    aria: {
                        label: e.label
                    }
                }, r, s, c, d);
            u.addEventListener(e.prefix + ":focus", function () {
                s.focus()
            });
            var h = !1,
                m = "";
            return u.addEventListener("DOMNodeInserted", function t() {
                u.parentNode && (u.removeEventListener("DOMNodeInserted", t), i(u, e.prefix + ":update", e))
            }), u.addEventListener(e.prefix + ":update", function () {
                u.ownerDocument.defaultView.matchMedia(e.matchMedia || "(max-width: 720px)").addListener(n), s.addEventListener("input", n), u.addEventListener("reset", n), u.addEventListener("submit", a), u.addEventListener(e.prefix + ":unload", onunload)
            }), u
        },
        p = function () {
            [].forEach.call(document.querySelectorAll(".n-gateway-search"), function (e) {
                var t = m({
                    prefix: "n-gateway-search",
                    action: e.getAttribute("data-action"),
                    label: "Esri Blog",
                    submitLabel: "Search",
                    cancelLabel: "Cancel",
                    queryLabel: "Search"
                });

                if (window && window.isMultisite) {
                    t.querySelector("input").name = "search", e.appendChild(t), n(e)
                } else {
                    t.querySelector("input").name = "s", e.appendChild(t), n(e)
                }
                
            })
        },
        f = function () {
            function e(t, i) {
                var n = this;
                r(this, e), this.target = t;
                var a = this.opts = {};
                for (var s in e.defaults) a[s] = i && s in i ? i[s] : e.defaults[s];
                this.menu = {
                    link: t.querySelector(a.menuControlSelector),
                    menu: t.querySelector(a.submenuSelector),
                    list: t.querySelector(a.sublistSelector),
                    parent: t.querySelector(a.menuSelector),
                    target: t
                }, this.menu.isExpanded = "true" === this.menu.link.getAttribute("aria-expanded"), this.menu.menu.id = this.menu.menu.id || "snav-" + ++e.uuid, this.menu.link.setAttribute("aria-controls", this.menu.menu.id), this.menu.link.setAttribute("aria-expanded", this.menu.isExpanded), this.menu.isExpanded ? t.setAttribute("data-expanded", "") : t.removeAttribute("data-expanded"), this.menus = [this.menu].concat(Array.prototype.slice.call(t.querySelectorAll(a.menusSelector)).map(function (t) {
                    var i = t.parentNode.querySelector(a.sublinkSelector),
                        n = "true" === i.getAttribute("aria-expanded");
                    return t.id = t.id || "snav-" + ++e.uuid, i.setAttribute("aria-controls", t.id), i.setAttribute("aria-expanded", n), t.setAttribute("aria-hidden", !n), {
                        isExpanded: n,
                        link: i,
                        menu: t
                    }
                })), this.more = t.querySelector(a.moreSelector), this.isSmall = window.matchMedia("(max-width: 615px)"), this.isSmallOrMedium = window.matchMedia("(max-width: 975px)"), this.isSmall.addListener(function () {
                    return n.onmediachange()
                }), this.onmediachange(), this.menus.forEach(function (e) {
                    window.addEventListener("click", function (t) {
                        e.link.contains(t.target) ? (t.preventDefault(), n.toggleMenu(e)) : n.isSmallOrMedium.matches && !n.target.contains(t.target) ? n.toggleMenu(e, !1) : n.isSmallOrMedium.matches || e.menu.contains(t.target) || n.toggleMenu(e, !1)
                    }), window.addEventListener("keydown", function (t) {
                        27 === t.keyCode && n.toggleMenu(e, !1)
                    })
                });
                var o = document.getElementById("globalnav"),
                    l = null !== o ? o.offsetHeight : 56;
                this.targetScrollY = t.getBoundingClientRect().top + window.pageYOffset || l, this.isFixed = !1, window.addEventListener("scroll", function () {
                    n.onscroll()
                }), this.onscroll()
            }
            return s(e, [{
                key: "toggleMenu",
                value: function (e, t) {
                    var i = void 0 === t ? !e.isExpanded : t;
                    i !== e.isExpanded && (e.isExpanded = i, e.link.setAttribute("aria-expanded", i), e.menu.setAttribute("aria-hidden", !i), e.target && (i ? e.target.setAttribute("data-expanded", "") : e.target.removeAttribute("data-expanded")))
                }
            }, {
                key: "onmediachange",
                value: function () {
                    this.menu.menu.setAttribute("aria-hidden", this.isSmallOrMedium.matches && !this.menu.isExpanded), this.isSmall.matches ? (this.menu.menu.insertBefore(this.more, this.menu.list.nextSibling), this.menu.menu.setAttribute("role", "navigation"), this.menu.list.setAttribute("role", "navigation")) : (this.target.appendChild(this.more), this.menu.menu.setAttribute("role", "group"), this.menu.list.removeAttribute("role"))
                }
            }, {
                key: "onscroll",
                value: function () {
                    var e = window.pageYOffset >= this.targetScrollY;
                    e !== this.isFixed && (this.isFixed = e, e ? this.target.setAttribute("data-fixed", "") : this.target.removeAttribute("data-fixed"))
                }
            }]), e
        }();
    f.uuid = 0, f.defaults = {
        menuSelector: ".c-snav-menu",
        menuControlSelector: ".c-snav-menu-title",
        submenuSelector: ".c-snav-submenu",
        sublistSelector: ".c-snav-sublist",
        moreSelector: ".c-snav-more",
        menusSelector: ".c-snav-termenu",
        sublinkSelector: ".c-snav-sublink"
    };
    var v = function () {
        var e = document.querySelector(".c-snav");
        e && new f(e)
    },
        g = function () {
            [].forEach.call(document.querySelectorAll(".n-subscribe-action"), function (e, t) {
                function i(t) {
                    e.setAttribute("aria-expanded", t), n.setAttribute("aria-hidden", !t), t && !n.src && (n.src = "//go.pardot.com/l/82202/2017-04-25/d4tgkd")
                }
                var n = e.parentNode.querySelector(".n-subscribe-action ~ .n-subscribe-iframe");
                if (n) {
                    var a = e.id = e.id || "n-subscribe-action--" + t,
                        r = n.id = n.id || "n-subscribe-iframe--" + t,
                        s = "true" === e.getAttribute("aria-expanded");
                    e.setAttribute("aria-controls", r), e.setAttribute("aria-expanded", s), n.setAttribute("aria-labelledby", a), e.addEventListener("click", function () {
                        i(s = !s)
                    }), i(s)
                }
            })
        },
        b = function () {
            function e(e) {
                var t = screen.width / 2 - 250,
                    i = screen.height / 2 - 150;
                window.open(e, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=500,height=300,top=" + i + ",left=" + t + ")")
            }
            Array.prototype.slice.call(document.querySelectorAll("[data-sharing]")).forEach(function (t) {
                t.addEventListener("click", function (event) {
                    event.preventDefault(), e(t.getAttribute("data-sharing"))
                })
            })
        },
        y = function () {
            var e = function (e) {
                function t() {
                    d.call(e, u + m, t);
                    var s = {
                        boxSizing: "content-box",
                        display: "inline-block",
                        overflow: "hidden"
                    };
                    "backgroundColor backgroundImage borderColor borderStyle borderWidth bottom fontSize lineHeight height left opacity margin position right top visibility width".replace(/\w+/g, function (e) {
                        s[e] = l[e]
                    }), o.border = o.margin = o.padding = 0, o.display = "block", o.height = o.width = "auto", o.opacity = 1;
                    var c = e.videoWidth || e.width,
                        p = e.videoHeight || e.height,
                        f = c / p,
                        v = document.createElement("object-fit");
                    v.appendChild(e.parentNode.replaceChild(v, e));
                    for (var g in s) v.runtimeStyle[g] = s[g];
                    var b;
                    "fill" === i ? h ? (o.width = n, o.height = a) : (o["-ms-transform-origin"] = "0% 0%", o["-ms-transform"] = "scale(" + n / c + "," + a / p + ")") : (f < r ? "contain" === i : "cover" === i) ? (b = a * f, o.width = Math.round(b) + "px", o.height = a + "px", o.marginLeft = Math.round((n - b) / 2) + "px") : (b = n / f, o.width = n + "px", o.height = Math.round(b) + "px", o.marginTop = Math.round((a - b) / 2) + "px")
                }
                var i = e.currentStyle ? e.currentStyle["object-fit"] : null;
                if (i && /^(contain|cover|fill)$/.test(i)) {
                    var n = e.clientWidth,
                        a = e.clientHeight,
                        r = n / a,
                        s = e.nodeName.toLowerCase(),
                        o = e.runtimeStyle,
                        l = e.currentStyle,
                        c = e.addEventListener || e.attachEvent,
                        d = e.removeEventListener || e.detachEvent,
                        u = e.addEventListener ? "" : "on",
                        h = "img" === s,
                        m = h ? "load" : "loadedmetadata";
                    c.call(e, u + m, t), e.complete && t()
                }
            };
            e.init = function () {
                if (document.body)
                    for (var t = document.querySelectorAll("img,video"), i = -1; t[++i];) e(t[i]);
                else setTimeout(e.init)
            }, /MSIE|Trident/.test(navigator.userAgent) && e.init()
        };
    ! function (e) {
        ! function t() {
            /c/.test(document.readyState) && document.body ? (document.removeEventListener("DOMContentLoaded", t), e()) : document.addEventListener("DOMContentLoaded", t)
        }()
    }(function () {
        v(), l(), h(), p(), g(), a(), b(), y()
    })
}();
//# sourceMappingURL=newsroom.js.map
// Show hide card summaries on tablet/mobile

var showSummaryLinks = Array.prototype.slice.call(document.querySelectorAll('.n-gateway-card-show-summary'));
toggleShowSummary(showSummaryLinks, "add");

var hideSummaryLinks = Array.prototype.slice.call(document.querySelectorAll('.n-gateway-card-hide-summary'));
toggleShowSummary(hideSummaryLinks, "remove");

function toggleShowSummary(linkArr, action) {

	if (linkArr.length > 0) {
		linkArr.forEach(function (showlink) {
			showlink.addEventListener("click", function () {
				this.parentNode.parentNode.classList[action]('show-summary');
				event.stopPropagation();
			});
		})
	}

}


// Podcast Player

var player = document.getElementById('music'); // id for audio element

if (player) {
	var audioPlayer = (function () {
		var podcast = '';

		/*********** public functions ***********/

		function init($player) {
			podcast = $player
			// play button event listenter
			pButton.addEventListener("click", play);

			// timeupdate event listener
			podcast.addEventListener("timeupdate", timeUpdate, false);

			// makes timeline clickable
			timeline.addEventListener("click", function (event) {
                moveplayhead(event);
				podcast.currentTime = duration * clickPercent(event);
			}, false);

			// makes playhead draggable
			playhead.addEventListener('mousedown', mouseDown, false);
			window.addEventListener('mouseup', mouseUp, false);

			audioVolume.addEventListener("mouseover", function () {
				setOriginalVolume()
			}, false);

			volumeSlider.addEventListener("click", function (e) {
				updateVolume(e);

			}, false);

			// Gets audio file duration
			podcast.addEventListener("canplaythrough", function () {
				duration = podcast.duration;
			}, false);
		}


		/*********** private properties **************/
		//Internal var

		var duration = podcast.duration, // Duration of audio clip, calculated here for embedding purposes
			pButton = document.getElementById('pButton'),// play button
			playhead = document.getElementById('playhead'), // playhead
			timeline = document.getElementById('timeline'), // timeline
			durationElm = Array.prototype.slice.call(document.querySelectorAll('#audioplayer .duration'))[0], // duration span
			currentTimeElm = Array.prototype.slice.call(document.querySelectorAll('#audioplayer .current-time'))[0],
			audioVolume = Array.prototype.slice.call(document.querySelectorAll('.audio-volume'))[0],
			volumeSlider = Array.prototype.slice.call(audioVolume.querySelectorAll('.volume-slider'))[0],
            volumeState = Array.prototype.slice.call(audioVolume.querySelectorAll('.volume-state'))[0];
            
        if (duration === Infinity) {
            podcast.currentTime = 24 * 60 * 60;
            podcast.ontimeupdate = function () {
                duration = podcast.duration;
            }
        }

		// Boolean value so that audio position is updated only when the playhead is released
		var onplayhead = false;

		// timeline width adjusted for playhead
		var timelineWidth = timeline.offsetWidth - playhead.offsetWidth;

		/******** private functions ************/
		// mouseDown EventListener
		function mouseDown() {
			onplayhead = true;
			window.addEventListener('mousemove', moveplayhead, true);
			podcast.removeEventListener('timeupdate', timeUpdate, false);
		}

		// mouseUp EventListener
		// getting input from all mouse clicks
		function mouseUp(event) {
			if (onplayhead == true) {
				moveplayhead(event);
				window.removeEventListener('mousemove', moveplayhead, true);
				// change current time
				podcast.currentTime = duration * clickPercent(event);
				podcast.addEventListener('timeupdate', timeUpdate, false);
			}
			onplayhead = false;
		}
		// mousemove EventListener
		// Moves playhead as user drags
		function moveplayhead(event) {
			var newMargLeft = event.clientX - getPosition(timeline);

			if (newMargLeft >= 0 && newMargLeft <= timelineWidth) {
				playhead.style.width = newMargLeft + "px";
			}
			if (newMargLeft < 0) {
				playhead.style.width = "0px";
			}
			if (newMargLeft > timelineWidth) {
				playhead.style.width = timelineWidth + "px";
			}
		}

		// timeUpdate
		// Synchronizes playhead position with current point in audio
		function timeUpdate() {
			var playPercent = timelineWidth * (podcast.currentTime / duration);
			playhead.style.width = playPercent + "px";
			currentTimeElm.innerHTML = timeFormat(podcast.currentTime);
			if (podcast.currentTime == duration) {
				pButton.className = "";
				pButton.className = "play";
			}
		}

		//Play and Pause
		function play() {
			// start podcast
			durationElm.innerHTML = timeFormat(podcast.duration);
			if (podcast.paused) {
				podcast.play();
				// remove play, add pause
				pButton.className = "";
				pButton.className = "pause-btn";
			} else { // pause music
				podcast.pause();
				// remove pause, add play
				pButton.className = "";
				pButton.className = "play-btn play";
			}
		}

		function timeFormat(time) {
			// Hours, minutes and seconds
			var hrs = Math.floor(time / 3600);
			var mins = Math.floor((time % 3600) / 60);
			var secs = Math.floor(time % 60);

			// Output like "1:01" or "4:03:59" or "123:03:59"
			var ret = "";

			if (hrs > 0) {
				ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
			}

			ret += "" + mins + ":" + (secs < 10 ? "0" : "");
			ret += "" + secs;
			return ret;
		}

		// getPosition
		// Returns elements left position relative to top-left of viewport
		function getPosition(el) {
			return el.getBoundingClientRect().left;
		}

		function setOriginalVolume() {
			volumeState.style.height = Math.floor(podcast.volume * 100) + "%";
		}

		function updateVolume(e) {
			var clickY = e.clientY - volumeSlider.getBoundingClientRect().top;
			podcast.volume = (100 - clickY) / 100;
			volumeState.style.height = Math.floor(100 - clickY) + "%";
		}

		// returns click as decimal (.77) of the total timelineWidth
		function clickPercent(event) {
			return (event.clientX - getPosition(timeline)) / timelineWidth;
		}


		/****************** return obj **************/
		return {
			init: init
		}
	}());
	audioPlayer.init(player);
}

// sticky share component
document.addEventListener("DOMContentLoaded", function (event) {
	var container;


	// social media nav
	Array.prototype.forEach.call(
		document.querySelectorAll('.news-share.legacy'),
		function (target) {
			// containing element and its bottom distance from the top of the document
			container = document.getElementsByTagName("body")[0];

			var offset = 90;

			// target top distance from the top of the document
			var targetTop = target.getBoundingClientRect().top + window.pageYOffset - offset;
			var targetBottom = container.getBoundingClientRect().bottom + window.pageYOffset - target.getBoundingClientRect().height - offset;
			var targetOffset = container.getBoundingClientRect().height - target.getBoundingClientRect().height;

			// whether the sticky target is absolute, fixed, or relative
			var state = 'absolute';

			// activate element
			window.addEventListener('scroll', onscroll);

			onscroll();

			function onscroll() {
				if (window.pageYOffset < targetTop) {
					if (state !== 'before') {
						target.setAttribute('data-stuck', state = 'before');
						target.style.top = '';
					}
				} else if (window.pageYOffset >= targetBottom) {
					if (state !== 'after') {
						target.setAttribute('data-stuck', state = 'after');
						target.style.top = targetOffset + "px";
					}
				} else if (state !== 'during') {
					target.setAttribute('data-stuck', state = 'during');
					target.style.top = '';
				}
			}

			Array.prototype.slice.call(
				document.querySelectorAll('[data-sharing]')
			).forEach(function (control) {
				control.addEventListener('click', function () {
					console.log('1');
					event.preventDefault(event);
					popupOpen(control.getAttribute('data-sharing'));
				});
			});

			function popupOpen(url) {
				var width = 500;
				var height = 300;
				var left = screen.width / 2 - width / 2;
				var top = screen.height / 2 - height / 2;

				window.open(
					url,
					'',
					'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=' + width + ',height=' + height + ',top=' + top + 'left=' + left
				);
			}
		});

	// Search label
	[].forEach.call(document.querySelectorAll('.n-gateway-search-label'), function (tag) {
		tag.innerHTML = "Search";
	});

	[].forEach.call(document.querySelectorAll('[data-search-tag]'), function (tag) {
		let tagString = tag.getAttribute('data-search-tag');
		let searchLabel = tag.querySelector('.n-gateway-search-label');
		searchLabel.innerHTML = tagString;
	});

	//Dynamic heading with carousel
	var $characterLength = 59;
	[].forEach.call(document.querySelectorAll('.n-gateway-carousel-article-headline'), function (item) {
		if (item.textContent.length > $characterLength) {
			item.classList.add('long-heading');
		}
	});

});

// Gallery navigation
// extending Jon Nail's gallery
// add image icons to gallery nav

var galleryNav = function () {
	var curr_gall = null;

	function set_gallery(gallery) {
		curr_gall = gallery;
	}

	function get_gall_nav_buttons() {
		var gall_id = curr_gall.getAttribute('id'),
			gall_label = 'nav[aria-labelledby="' + gall_id + '"]',
			gall_nav = document.querySelector(gall_label);
		return Array.prototype.slice.call(gall_nav.querySelectorAll('button'));

	}

	function get_gall_slide_images() {
		var gall_images = Array.prototype.slice.call(curr_gall.querySelectorAll('.n-gallery-image-src'));
		var img_src_arr = gall_images.map(function (img) {
			return img.getAttribute('src');
		});
		return img_src_arr;
	}

	function set_gall_image_icons() {
		var gall_nav_buttons = get_gall_nav_buttons(),
			gall_slides = get_gall_slide_images();

		gall_nav_buttons.forEach(function (button, index) {
			button.style.backgroundImage = "url('" + gall_slides[index] + "')";
		})
	}

	function init(gallery) {
		set_gallery(gallery);
		set_gall_image_icons();
	}

	return {
		init: init
	}
}();

document.addEventListener("DOMContentLoaded", function (event) {
	var galleryArr = Array.prototype.slice.call(document.querySelectorAll('.n-gallery'));

	if (galleryArr.length > 0) {
		galleryArr.forEach(function (thisGallery) {
			galleryNav.init(thisGallery);
		});
	}
});

class Closest {
    // Polyfill for browser that do not support closest()
    constructor(groupReadyId) {
        if (!Element.prototype.matches)
            Element.prototype.matches = Element.prototype.msMatchesSelector ||
                Element.prototype.webkitMatchesSelector;

        if (!Element.prototype.closest) {
            Element.prototype.closest = function (s) {
                var el = this;
                if (!document.documentElement.contains(el)) return null;
                do {
                    if (el.matches(s)) return el;
                    el = el.parentElement || el.parentNode;
                } while (el !== null && el.nodeType === 1);
                return null;
            };
        }
    }
}

new Closest();
/*
 * File: iframeResizer.js
 * Desc: Force iframes to size to content.
 * Requires: iframeResizer.contentWindow.js to be loaded into the target frame.
 * Doc: https://github.com/davidjbradshaw/iframe-resizer
 * Author: David J. Bradshaw - dave@bradshaw.net
 * Contributor: Jure Mav - jure.mav@gmail.com
 * Contributor: Reed Dadoune - reed@dadoune.com
 */


;(function(window) {
  'use strict';

  var
    count                 = 0,
    logEnabled            = false,
    hiddenCheckEnabled    = false,
    msgHeader             = 'message',
    msgHeaderLen          = msgHeader.length,
    msgId                 = '[iFrameSizer]', //Must match iframe msg ID
    msgIdLen              = msgId.length,
    pagePosition          = null,
    requestAnimationFrame = window.requestAnimationFrame,
    resetRequiredMethods  = {max:1,scroll:1,bodyScroll:1,documentElementScroll:1},
    settings              = {},
    timer                 = null,
    logId                 = 'Host Page',

    defaults              = {
      autoResize                : true,
      bodyBackground            : null,
      bodyMargin                : null,
      bodyMarginV1              : 8,
      bodyPadding               : null,
      checkOrigin               : true,
      inPageLinks               : false,
      enablePublicMethods       : true,
      heightCalculationMethod   : 'bodyOffset',
      id                        : 'iFrameResizer',
      interval                  : 32,
      log                       : false,
      maxHeight                 : Infinity,
      maxWidth                  : Infinity,
      minHeight                 : 0,
      minWidth                  : 0,
      resizeFrom                : 'parent',
      scrolling                 : false,
      sizeHeight                : true,
      sizeWidth                 : false,
      tolerance                 : 0,
      widthCalculationMethod    : 'scroll',
      closedCallback            : function(){},
      initCallback              : function(){},
      messageCallback           : function(){warn('MessageCallback function not defined');},
      resizedCallback           : function(){},
      scrollCallback            : function(){return true;}
    };

  function addEventListener(obj,evt,func){
    /* istanbul ignore else */ // Not testable in PhantonJS
    if ('addEventListener' in window){
      obj.addEventListener(evt,func, false);
    } else if ('attachEvent' in window){//IE
      obj.attachEvent('on'+evt,func);
    }
  }

  function removeEventListener(el,evt,func){
    /* istanbul ignore else */ // Not testable in phantonJS
    if ('removeEventListener' in window){
      el.removeEventListener(evt,func, false);
    } else if ('detachEvent' in window){ //IE
      el.detachEvent('on'+evt,func);
    }
  }

  function setupRequestAnimationFrame(){
    var
      vendors = ['moz', 'webkit', 'o', 'ms'],
      x;

    // Remove vendor prefixing if prefixed and break early if not
    for (x = 0; x < vendors.length && !requestAnimationFrame; x += 1) {
      requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
    }

    if (!(requestAnimationFrame)){
      log('setup','RequestAnimationFrame not supported');
    }
  }

  function getMyID(iframeId){
    var retStr = 'Host page: '+iframeId;

    if (window.top!==window.self){
      if (window.parentIFrame && window.parentIFrame.getId){
        retStr = window.parentIFrame.getId()+': '+iframeId;
      } else {
        retStr = 'Nested host page: '+iframeId;
      }
    }

    return retStr;
  }

  function formatLogHeader(iframeId){
    return msgId + '[' + getMyID(iframeId) + ']';
  }

  function isLogEnabled(iframeId){
    return settings[iframeId] ? settings[iframeId].log : logEnabled;
  }

  function log(iframeId,msg){
    output('log',iframeId,msg,isLogEnabled(iframeId));
  }

  function info(iframeId,msg){
    output('info',iframeId,msg,isLogEnabled(iframeId));
  }

  function warn(iframeId,msg){
    output('warn',iframeId,msg,true);
  }

  function output(type,iframeId,msg,enabled){
    if (true === enabled && 'object' === typeof window.console){
      console[type](formatLogHeader(iframeId),msg);
    }
  }

  function iFrameListener(event){
    function resizeIFrame(){
      function resize(){
        setSize(messageData);
        setPagePosition(iframeId);
      }

      ensureInRange('Height');
      ensureInRange('Width');

      syncResize(resize,messageData,'init');
    }

    function processMsg(){
      var data = msg.substr(msgIdLen).split(':');

      return {
        iframe: settings[data[0]].iframe,
        id:     data[0],
        height: data[1],
        width:  data[2],
        type:   data[3]
      };
    }

    function ensureInRange(Dimension){
      var
        max  = Number(settings[iframeId]['max' + Dimension]),
        min  = Number(settings[iframeId]['min' + Dimension]),
        dimension = Dimension.toLowerCase(),
        size = Number(messageData[dimension]);

      log(iframeId,'Checking ' + dimension + ' is in range ' + min + '-' + max);

      if (size<min) {
        size=min;
        log(iframeId,'Set ' + dimension + ' to min value');
      }

      if (size>max) {
        size=max;
        log(iframeId,'Set ' + dimension + ' to max value');
      }

      messageData[dimension] = '' + size;
    }


    function isMessageFromIFrame(){
      function checkAllowedOrigin(){
        function checkList(){
          var
            i = 0,
            retCode = false;

          log(iframeId,'Checking connection is from allowed list of origins: ' + checkOrigin);

          for (; i < checkOrigin.length; i++) {
            if (checkOrigin[i] === origin) {
              retCode = true;
              break;
            }
          }
          return retCode;
        }

        function checkSingle(){
          var remoteHost  = settings[iframeId].remoteHost;
          log(iframeId,'Checking connection is from: '+remoteHost);
          return origin === remoteHost;
        }

        return checkOrigin.constructor === Array ? checkList() : checkSingle();
      }

      var
        origin      = event.origin,
        checkOrigin = settings[iframeId].checkOrigin;

      if (checkOrigin && (''+origin !== 'null') && !checkAllowedOrigin()) {
        throw new Error(
          'Unexpected message received from: ' + origin +
          ' for ' + messageData.iframe.id +
          '. Message was: ' + event.data +
          '. This error can be disabled by setting the checkOrigin: false option or by providing of array of trusted domains.'
        );
      }

      return true;
    }

    function isMessageForUs(){
      return msgId === (('' + msg).substr(0,msgIdLen)) && (msg.substr(msgIdLen).split(':')[0] in settings); //''+Protects against non-string msg
    }

    function isMessageFromMetaParent(){
      //Test if this message is from a parent above us. This is an ugly test, however, updating
      //the message format would break backwards compatibity.
      var retCode = messageData.type in {'true':1,'false':1,'undefined':1};

      if (retCode){
        log(iframeId,'Ignoring init message from meta parent page');
      }

      return retCode;
    }

    function getMsgBody(offset){
      return msg.substr(msg.indexOf(':')+msgHeaderLen+offset);
    }

    function forwardMsgFromIFrame(msgBody){
      log(iframeId,'MessageCallback passed: {iframe: '+ messageData.iframe.id + ', message: ' + msgBody + '}');
      callback('messageCallback',{
        iframe: messageData.iframe,
        message: JSON.parse(msgBody)
      });
      log(iframeId,'--');
    }

    function getPageInfo(){
      var
        bodyPosition   = document.body.getBoundingClientRect(),
        iFramePosition = messageData.iframe.getBoundingClientRect();

      return JSON.stringify({
        clientHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
        clientWidth:  Math.max(document.documentElement.clientWidth,  window.innerWidth  || 0),
        offsetTop:    parseInt(iFramePosition.top  - bodyPosition.top,  10),
        offsetLeft:   parseInt(iFramePosition.left - bodyPosition.left, 10),
        scrollTop:    window.pageYOffset,
        scrollLeft:   window.pageXOffset
      });
    }

    function sendPageInfoToIframe(iframe,iframeId){
      function debouncedTrigger(){
        trigger(
          'Send Page Info',
          'pageInfo:' + getPageInfo(),
          iframe,
          iframeId
        );
      }

      debouce(debouncedTrigger,32);
    }


    function startPageInfoMonitor(){
      function setListener(type,func){
        function sendPageInfo(){
          if (settings[id]){
            sendPageInfoToIframe(settings[id].iframe,id);
          } else {
            stop();
          }
        }

        ['scroll','resize'].forEach(function(evt){
          log(id, type +  evt + ' listener for sendPageInfo');
          func(window,evt,sendPageInfo);
        });
      }

      function stop(){
        setListener('Remove ', removeEventListener);
      }

      function start(){
        setListener('Add ', addEventListener);
      }

      var id = iframeId; //Create locally scoped copy of iFrame ID

      start();

      settings[id].stopPageInfo = stop;
    }

    function stopPageInfoMonitor(){
      if (settings[iframeId] && settings[iframeId].stopPageInfo){
        settings[iframeId].stopPageInfo();
        delete settings[iframeId].stopPageInfo;
      }
    }

    function checkIFrameExists(){
      var retBool = true;

      if (null === messageData.iframe) {
        warn(iframeId,'IFrame ('+messageData.id+') not found');
        retBool = false;
      }
      return retBool;
    }

    function getElementPosition(target){
      var iFramePosition = target.getBoundingClientRect();

      getPagePosition(iframeId);

      return {
        x: Math.floor( Number(iFramePosition.left) + Number(pagePosition.x) ),
        y: Math.floor( Number(iFramePosition.top)  + Number(pagePosition.y) )
      };
    }

    function scrollRequestFromChild(addOffset){
      /* istanbul ignore next */  //Not testable in Karma
      function reposition(){
        pagePosition = newPosition;
        scrollTo();
        log(iframeId,'--');
      }

      function calcOffset(){
        return {
          x: Number(messageData.width) + offset.x,
          y: Number(messageData.height) + offset.y
        };
      }

      function scrollParent(){
        if (window.parentIFrame){
          window.parentIFrame['scrollTo'+(addOffset?'Offset':'')](newPosition.x,newPosition.y);
        } else {
          warn(iframeId,'Unable to scroll to requested position, window.parentIFrame not found');
        }
      }

      var
        offset = addOffset ? getElementPosition(messageData.iframe) : {x:0,y:0},
        newPosition = calcOffset();

      log(iframeId,'Reposition requested from iFrame (offset x:'+offset.x+' y:'+offset.y+')');

      if(window.top!==window.self){
        scrollParent();
      } else {
        reposition();
      }
    }

    function scrollTo(){
      if (false !== callback('scrollCallback',pagePosition)){
        setPagePosition(iframeId);
      } else {
        unsetPagePosition();
      }
    }

    function findTarget(location){
      function jumpToTarget(){
        var jumpPosition = getElementPosition(target);

        log(iframeId,'Moving to in page link (#'+hash+') at x: '+jumpPosition.x+' y: '+jumpPosition.y);
        pagePosition = {
          x: jumpPosition.x,
          y: jumpPosition.y
        };

        scrollTo();
        log(iframeId,'--');
      }

      function jumpToParent(){
        if (window.parentIFrame){
          window.parentIFrame.moveToAnchor(hash);
        } else {
          log(iframeId,'In page link #'+hash+' not found and window.parentIFrame not found');
        }
      }

      var
        hash     = location.split('#')[1] || '',
        hashData = decodeURIComponent(hash),
        target   = document.getElementById(hashData) || document.getElementsByName(hashData)[0];

      if (target){
        jumpToTarget();
      } else if(window.top!==window.self){
        jumpToParent();
      } else {
        log(iframeId,'In page link #'+hash+' not found');
      }
    }

    function callback(funcName,val){
      return chkCallback(iframeId,funcName,val);
    }

    function actionMsg(){

      if(settings[iframeId].firstRun) firstRun();

      switch(messageData.type){
        case 'close':
          closeIFrame(messageData.iframe);
          break;
        case 'message':
          forwardMsgFromIFrame(getMsgBody(6));
          break;
        case 'scrollTo':
          scrollRequestFromChild(false);
          break;
        case 'scrollToOffset':
          scrollRequestFromChild(true);
          break;
        case 'pageInfo':
          sendPageInfoToIframe(settings[iframeId].iframe,iframeId);
          startPageInfoMonitor();
          break;
        case 'pageInfoStop':
          stopPageInfoMonitor();
          break;
        case 'inPageLink':
          findTarget(getMsgBody(9));
          break;
        case 'reset':
          resetIFrame(messageData);
          break;
        case 'init':
          resizeIFrame();
          callback('initCallback',messageData.iframe);
          callback('resizedCallback',messageData);
          break;
        default:
          resizeIFrame();
          callback('resizedCallback',messageData);
      }
    }

    function hasSettings(iframeId){
      var retBool = true;

      if (!settings[iframeId]){
        retBool = false;
        warn(messageData.type + ' No settings for ' + iframeId + '. Message was: ' + msg);
      }

      return retBool;
    }

    function iFrameReadyMsgReceived(){
      for (var iframeId in settings){
        trigger('iFrame requested init',createOutgoingMsg(iframeId),document.getElementById(iframeId),iframeId);
      }
    }

    function firstRun() {
      settings[iframeId].firstRun = false;
    }

    var
      msg = event.data,
      messageData = {},
      iframeId = null;

    if('[iFrameResizerChild]Ready' === msg){
      iFrameReadyMsgReceived();
    } else if (isMessageForUs()){
      messageData = processMsg();
      iframeId    = logId = messageData.id;

      if (!isMessageFromMetaParent() && hasSettings(iframeId)){
        log(iframeId,'Received: '+msg);

        if ( checkIFrameExists() && isMessageFromIFrame() ){
          actionMsg();
        }
      }
    } else {
      info(iframeId,'Ignored: '+msg);
    }

  }


  function chkCallback(iframeId,funcName,val){
    var
      func = null,
      retVal = null;

    if(settings[iframeId]){
      func = settings[iframeId][funcName];

      if( 'function' === typeof func){
        retVal = func(val);
      } else {
        throw new TypeError(funcName+' on iFrame['+iframeId+'] is not a function');
      }
    }

    return retVal;
  }

  function closeIFrame(iframe){
    var iframeId = iframe.id;

    log(iframeId,'Removing iFrame: '+iframeId);
    iframe.parentNode.removeChild(iframe);
    chkCallback(iframeId,'closedCallback',iframeId);
    log(iframeId,'--');
    delete settings[iframeId];
  }

  function getPagePosition(iframeId){
    if(null === pagePosition){
      pagePosition = {
        x: (window.pageXOffset !== undefined) ? window.pageXOffset : document.documentElement.scrollLeft,
        y: (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop
      };
      log(iframeId,'Get page position: '+pagePosition.x+','+pagePosition.y);
    }
  }

  function setPagePosition(iframeId){
    if(null !== pagePosition){
      window.scrollTo(pagePosition.x,pagePosition.y);
      log(iframeId,'Set page position: '+pagePosition.x+','+pagePosition.y);
      unsetPagePosition();
    }
  }

  function unsetPagePosition(){
    pagePosition = null;
  }

  function resetIFrame(messageData){
    function reset(){
      setSize(messageData);
      trigger('reset','reset',messageData.iframe,messageData.id);
    }

    log(messageData.id,'Size reset requested by '+('init'===messageData.type?'host page':'iFrame'));
    getPagePosition(messageData.id);
    syncResize(reset,messageData,'reset');
  }

  function setSize(messageData){
    function setDimension(dimension){
      messageData.iframe.style[dimension] = messageData[dimension] + 'px';
      log(
        messageData.id,
        'IFrame (' + iframeId +
        ') ' + dimension +
        ' set to ' + messageData[dimension] + 'px'
      );
    }

    function chkZero(dimension){
      //FireFox sets dimension of hidden iFrames to zero.
      //So if we detect that set up an event to check for
      //when iFrame becomes visible.

      /* istanbul ignore next */  //Not testable in PhantomJS
      if (!hiddenCheckEnabled && '0' === messageData[dimension]){
        hiddenCheckEnabled = true;
        log(iframeId,'Hidden iFrame detected, creating visibility listener');
        fixHiddenIFrames();
      }
    }

    function processDimension(dimension){
      setDimension(dimension);
      chkZero(dimension);
    }

    var iframeId = messageData.iframe.id;

    if(settings[iframeId]){
      if( settings[iframeId].sizeHeight) { processDimension('height'); }
      if( settings[iframeId].sizeWidth ) { processDimension('width'); }
    }
  }

  function syncResize(func,messageData,doNotSync){
    /* istanbul ignore if */  //Not testable in PhantomJS
    if(doNotSync!==messageData.type && requestAnimationFrame){
      log(messageData.id,'Requesting animation frame');
      requestAnimationFrame(func);
    } else {
      func();
    }
  }

  function trigger(calleeMsg,msg,iframe,id){
    function postMessageToIFrame(){
      var target = settings[id].targetOrigin;
      log(id,'[' + calleeMsg + '] Sending msg to iframe['+id+'] ('+msg+') targetOrigin: '+target);
      iframe.contentWindow.postMessage( msgId + msg, target );
    }

    function iFrameNotFound(){
      info(id,'[' + calleeMsg + '] IFrame('+id+') not found');
      if(settings[id]) {
        delete settings[id];
      }
    }

    function chkAndSend(){
      if(iframe && 'contentWindow' in iframe && (null !== iframe.contentWindow)){ //Null test for PhantomJS
        postMessageToIFrame();
      } else {
        iFrameNotFound();
      }
    }

    id = id || iframe.id;

    if(settings[id]) {
      chkAndSend();
    }

  }

  function createOutgoingMsg(iframeId){
    return iframeId +
      ':' + settings[iframeId].bodyMarginV1 +
      ':' + settings[iframeId].sizeWidth +
      ':' + settings[iframeId].log +
      ':' + settings[iframeId].interval +
      ':' + settings[iframeId].enablePublicMethods +
      ':' + settings[iframeId].autoResize +
      ':' + settings[iframeId].bodyMargin +
      ':' + settings[iframeId].heightCalculationMethod +
      ':' + settings[iframeId].bodyBackground +
      ':' + settings[iframeId].bodyPadding +
      ':' + settings[iframeId].tolerance +
      ':' + settings[iframeId].inPageLinks +
      ':' + settings[iframeId].resizeFrom +
      ':' + settings[iframeId].widthCalculationMethod;
  }

  function setupIFrame(iframe,options){
    function setLimits(){
      function addStyle(style){
        if ((Infinity !== settings[iframeId][style]) && (0 !== settings[iframeId][style])){
          iframe.style[style] = settings[iframeId][style] + 'px';
          log(iframeId,'Set '+style+' = '+settings[iframeId][style]+'px');
        }
      }

      function chkMinMax(dimension){
        if (settings[iframeId]['min'+dimension]>settings[iframeId]['max'+dimension]){
          throw new Error('Value for min'+dimension+' can not be greater than max'+dimension);
        }
      }

      chkMinMax('Height');
      chkMinMax('Width');

      addStyle('maxHeight');
      addStyle('minHeight');
      addStyle('maxWidth');
      addStyle('minWidth');
    }

    function newId(){
      var id = ((options && options.id) || defaults.id + count++);
      if  (null!==document.getElementById(id)){
        id = id + count++;
      }
      return id;
    }

    function ensureHasId(iframeId){
      logId=iframeId;
      if (''===iframeId){
        iframe.id = iframeId =  newId();
        logEnabled = (options || {}).log;
        logId=iframeId;
        log(iframeId,'Added missing iframe ID: '+ iframeId +' (' + iframe.src + ')');
      }


      return iframeId;
    }

    function setScrolling(){
      log(iframeId,'IFrame scrolling ' + (settings[iframeId].scrolling ? 'enabled' : 'disabled') + ' for ' + iframeId);
      iframe.style.overflow = false === settings[iframeId].scrolling ? 'hidden' : 'auto';
      iframe.scrolling      = false === settings[iframeId].scrolling ? 'no' : 'yes';
    }

    //The V1 iFrame script expects an int, where as in V2 expects a CSS
    //string value such as '1px 3em', so if we have an int for V2, set V1=V2
    //and then convert V2 to a string PX value.
    function setupBodyMarginValues(){
      if (('number'===typeof(settings[iframeId].bodyMargin)) || ('0'===settings[iframeId].bodyMargin)){
        settings[iframeId].bodyMarginV1 = settings[iframeId].bodyMargin;
        settings[iframeId].bodyMargin   = '' + settings[iframeId].bodyMargin + 'px';
      }
    }

    function checkReset(){
      // Reduce scope of firstRun to function, because IE8's JS execution
      // context stack is borked and this value gets externally
      // changed midway through running this function!!!
      var
        firstRun           = settings[iframeId].firstRun,
        resetRequertMethod = settings[iframeId].heightCalculationMethod in resetRequiredMethods;

      if (!firstRun && resetRequertMethod){
        resetIFrame({iframe:iframe, height:0, width:0, type:'init'});
      }
    }

    function setupIFrameObject(){
      if(Function.prototype.bind){ //Ignore unpolyfilled IE8.
        settings[iframeId].iframe.iFrameResizer = {

          close        : closeIFrame.bind(null,settings[iframeId].iframe),

          resize       : trigger.bind(null,'Window resize', 'resize', settings[iframeId].iframe),

          moveToAnchor : function(anchor){
            trigger('Move to anchor','inPageLink:'+anchor, settings[iframeId].iframe,iframeId);
          },

          sendMessage  : function(message){
            message = JSON.stringify(message);
            trigger('Send Message','message:'+message, settings[iframeId].iframe,iframeId);
          }
        };
      }
    }

    //We have to call trigger twice, as we can not be sure if all
    //iframes have completed loading when this code runs. The
    //event listener also catches the page changing in the iFrame.
    function init(msg){
      function iFrameLoaded(){
        trigger('iFrame.onload',msg,iframe);
        checkReset();
      }

      addEventListener(iframe,'load',iFrameLoaded);
      trigger('init',msg,iframe);
    }

    function checkOptions(options){
      if ('object' !== typeof options){
        throw new TypeError('Options is not an object');
      }
    }

    function copyOptions(options){
      for (var option in defaults) {
        if (defaults.hasOwnProperty(option)){
          settings[iframeId][option] = options.hasOwnProperty(option) ? options[option] : defaults[option];
        }
      }
    }

    function getTargetOrigin (remoteHost){
      return ('' === remoteHost || 'file://' === remoteHost) ? '*' : remoteHost;
    }

    function processOptions(options){
      options = options || {};
      settings[iframeId] = {
        firstRun	: true,
        iframe		: iframe,
        remoteHost	: iframe.src.split('/').slice(0,3).join('/')
      };

      checkOptions(options);
      copyOptions(options);

      settings[iframeId].targetOrigin = true === settings[iframeId].checkOrigin ? getTargetOrigin(settings[iframeId].remoteHost) : '*';
    }

    function beenHere(){
      return (iframeId in settings && 'iFrameResizer' in iframe);
    }

    var iframeId = ensureHasId(iframe.id);

    if (!beenHere()){
      processOptions(options);
      setScrolling();
      setLimits();
      setupBodyMarginValues();
      init(createOutgoingMsg(iframeId));
      setupIFrameObject();
    } else {
      warn(iframeId,'Ignored iFrame, already setup.');
    }
  }

  function debouce(fn,time){
    if (null === timer){
      timer = setTimeout(function(){
        timer = null;
        fn();
      }, time);
    }
  }

  /* istanbul ignore next */  //Not testable in PhantomJS
  function fixHiddenIFrames(){
    function checkIFrames(){
      function checkIFrame(settingId){
        function chkDimension(dimension){
          return '0px' === settings[settingId].iframe.style[dimension];
        }

        function isVisible(el) {
          return (null !== el.offsetParent);
        }

        if (isVisible(settings[settingId].iframe) && (chkDimension('height') || chkDimension('width'))){
          trigger('Visibility change', 'resize', settings[settingId].iframe,settingId);
        }
      }

      for (var settingId in settings){
        checkIFrame(settingId);
      }
    }

    function mutationObserved(mutations){
      log('window','Mutation observed: ' + mutations[0].target + ' ' + mutations[0].type);
      debouce(checkIFrames,16);
    }

    function createMutationObserver(){
      var
        target = document.querySelector('body'),

        config = {
          attributes            : true,
          attributeOldValue     : false,
          characterData         : true,
          characterDataOldValue : false,
          childList             : true,
          subtree               : true
        },

        observer = new MutationObserver(mutationObserved);

      observer.observe(target, config);
    }

    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

    if (MutationObserver) createMutationObserver();
  }


  function resizeIFrames(event){
    function resize(){
      sendTriggerMsg('Window '+event,'resize');
    }

    log('window','Trigger event: '+event);
    debouce(resize,16);
  }

  /* istanbul ignore next */  //Not testable in PhantomJS
  function tabVisible() {
    function resize(){
      sendTriggerMsg('Tab Visable','resize');
    }

    if('hidden' !== document.visibilityState) {
      log('document','Trigger event: Visiblity change');
      debouce(resize,16);
    }
  }

  function sendTriggerMsg(eventName,event){
    function isIFrameResizeEnabled(iframeId) {
      return	'parent' === settings[iframeId].resizeFrom &&
        settings[iframeId].autoResize &&
        !settings[iframeId].firstRun;
    }

    for (var iframeId in settings){
      if(isIFrameResizeEnabled(iframeId)){
        trigger(eventName,event,document.getElementById(iframeId),iframeId);
      }
    }
  }

  function setupEventListeners(){
    addEventListener(window,'message',iFrameListener);

    addEventListener(window,'resize', function(){resizeIFrames('resize');});

    addEventListener(document,'visibilitychange',tabVisible);
    addEventListener(document,'-webkit-visibilitychange',tabVisible); //Andriod 4.4
    addEventListener(window,'focusin',function(){resizeIFrames('focus');}); //IE8-9
    addEventListener(window,'focus',function(){resizeIFrames('focus');});
  }


  function factory(){
    function init(options,element){
      function chkType(){
        if(!element.tagName) {
          throw new TypeError('Object is not a valid DOM element');
        } else if ('IFRAME' !== element.tagName.toUpperCase()) {
          throw new TypeError('Expected <IFRAME> tag, found <'+element.tagName+'>');
        }
      }

      if(element) {
        chkType();
        setupIFrame(element, options);
        iFrames.push(element);
      }
    }

    var iFrames;

    setupRequestAnimationFrame();
    setupEventListeners();

    return function iFrameResizeF(options,target){
      iFrames = []; //Only return iFrames past in on this call

      switch (typeof(target)){
        case 'undefined':
        case 'string':
          Array.prototype.forEach.call(
            document.querySelectorAll( target || 'iframe' ),
            init.bind(undefined, options)
          );
          break;
        case 'object':
          init(options,target);
          break;
        default:
          throw new TypeError('Unexpected data type ('+typeof(target)+')');
      }

      return iFrames;
    };
  }

  function createJQueryPublicMethod($){
    $.fn.iFrameResize = function $iFrameResizeF(options) {
      return this.filter('iframe').each(function (index, element) {
        setupIFrame(element, options);
      }).end();
    };
  }

  if (window.jQuery) { createJQueryPublicMethod(jQuery); }

  if (typeof define === 'function' && define.amd) {
    define([],factory);
  } else if (typeof module === 'object' && typeof module.exports === 'object') { //Node for browserfy
    module.exports = factory();
  } else {
    window.iFrameResize = window.iFrameResize || factory();
  }

})(window || {});
/*
 * classList.js: Cross-browser full element.classList implementation.
 * 1.1.20170427
 *
 * By Eli Grey, http://eligrey.com
 * License: Dedicated to the public domain.
 *   See https://github.com/eligrey/classList.js/blob/master/LICENSE.md
 */

/*global self, document, DOMException */

/*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js */

if ("document" in window.self) {

// Full polyfill for browsers with no classList support
// Including IE < Edge missing SVGElement.classList
  if (!("classList" in document.createElement("_"))
    || document.createElementNS && !("classList" in document.createElementNS("http://www.w3.org/2000/svg","g"))) {

    (function (view) {

      "use strict";

      if (!('Element' in view)) return;

      var
        classListProp = "classList"
        , protoProp = "prototype"
        , elemCtrProto = view.Element[protoProp]
        , objCtr = Object
        , strTrim = String[protoProp].trim || function () {
            return this.replace(/^\s+|\s+$/g, "");
          }
        , arrIndexOf = Array[protoProp].indexOf || function (item) {
            var
              i = 0
              , len = this.length
              ;
            for (; i < len; i++) {
              if (i in this && this[i] === item) {
                return i;
              }
            }
            return -1;
          }
        // Vendors: please allow content code to instantiate DOMExceptions
        , DOMEx = function (type, message) {
          this.name = type;
          this.code = DOMException[type];
          this.message = message;
        }
        , checkTokenAndGetIndex = function (classList, token) {
          if (token === "") {
            throw new DOMEx(
              "SYNTAX_ERR"
              , "An invalid or illegal string was specified"
            );
          }
          if (/\s/.test(token)) {
            throw new DOMEx(
              "INVALID_CHARACTER_ERR"
              , "String contains an invalid character"
            );
          }
          return arrIndexOf.call(classList, token);
        }
        , ClassList = function (elem) {
          var
            trimmedClasses = strTrim.call(elem.getAttribute("class") || "")
            , classes = trimmedClasses ? trimmedClasses.split(/\s+/) : []
            , i = 0
            , len = classes.length
            ;
          for (; i < len; i++) {
            this.push(classes[i]);
          }
          this._updateClassName = function () {
            elem.setAttribute("class", this.toString());
          };
        }
        , classListProto = ClassList[protoProp] = []
        , classListGetter = function () {
          return new ClassList(this);
        }
        ;
// Most DOMException implementations don't allow calling DOMException's toString()
// on non-DOMExceptions. Error's toString() is sufficient here.
      DOMEx[protoProp] = Error[protoProp];
      classListProto.item = function (i) {
        return this[i] || null;
      };
      classListProto.contains = function (token) {
        token += "";
        return checkTokenAndGetIndex(this, token) !== -1;
      };
      classListProto.add = function () {
        var
          tokens = arguments
          , i = 0
          , l = tokens.length
          , token
          , updated = false
          ;
        do {
          token = tokens[i] + "";
          if (checkTokenAndGetIndex(this, token) === -1) {
            this.push(token);
            updated = true;
          }
        }
        while (++i < l);

        if (updated) {
          this._updateClassName();
        }
      };
      classListProto.remove = function () {
        var
          tokens = arguments
          , i = 0
          , l = tokens.length
          , token
          , updated = false
          , index
          ;
        do {
          token = tokens[i] + "";
          index = checkTokenAndGetIndex(this, token);
          while (index !== -1) {
            this.splice(index, 1);
            updated = true;
            index = checkTokenAndGetIndex(this, token);
          }
        }
        while (++i < l);

        if (updated) {
          this._updateClassName();
        }
      };
      classListProto.toggle = function (token, force) {
        token += "";

        var
          result = this.contains(token)
          , method = result ?
          force !== true && "remove"
            :
          force !== false && "add"
          ;

        if (method) {
          this[method](token);
        }

        if (force === true || force === false) {
          return force;
        } else {
          return !result;
        }
      };
      classListProto.toString = function () {
        return this.join(" ");
      };

      if (objCtr.defineProperty) {
        var classListPropDesc = {
          get: classListGetter
          , enumerable: true
          , configurable: true
        };
        try {
          objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
        } catch (ex) { // IE 8 doesn't support enumerable:true
          // adding undefined to fight this issue https://github.com/eligrey/classList.js/issues/36
          // modernie IE8-MSW7 machine has IE8 8.0.6001.18702 and is affected
          if (ex.number === undefined || ex.number === -0x7FF5EC54) {
            classListPropDesc.enumerable = false;
            objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
          }
        }
      } else if (objCtr[protoProp].__defineGetter__) {
        elemCtrProto.__defineGetter__(classListProp, classListGetter);
      }

    }(window.self));

  }

// There is full or partial native classList support, so just check if we need
// to normalize the add/remove and toggle APIs.

  (function () {
    "use strict";

    var testElement = document.createElement("_");

    testElement.classList.add("c1", "c2");

    // Polyfill for IE 10/11 and Firefox <26, where classList.add and
    // classList.remove exist but support only one argument at a time.
    if (!testElement.classList.contains("c2")) {
      var createMethod = function(method) {
        var original = DOMTokenList.prototype[method];

        DOMTokenList.prototype[method] = function(token) {
          var i, len = arguments.length;

          for (i = 0; i < len; i++) {
            token = arguments[i];
            original.call(this, token);
          }
        };
      };
      createMethod('add');
      createMethod('remove');
    }

    testElement.classList.toggle("c3", false);

    // Polyfill for IE 10 and Firefox <24, where classList.toggle does not
    // support the second argument.
    if (testElement.classList.contains("c3")) {
      var _toggle = DOMTokenList.prototype.toggle;

      DOMTokenList.prototype.toggle = function(token, force) {
        if (1 in arguments && !this.contains(token) === !force) {
          return force;
        } else {
          return _toggle.call(this, token);
        }
      };

    }

    testElement = null;
  }());

}
/*
 * FED general and common utility functions used for Newsroom
 * Feel free to add your own following below pattern 2.
 *
 */

let fed_powers = (function () {


	function get_arr($nodes) {

		return (typeof $nodes === 'string') ? Array.prototype.slice.call(document.querySelectorAll($nodes)) : Array.prototype.slice.call($nodes);
	}

	function get_first($nodes) {
		// return only the first element
		// use only when you know there is only one
		var firstElm = (typeof $nodes === 'string') ? Array.prototype.slice.call(document.querySelectorAll($nodes)) : Array.prototype.slice.call($nodes);
		return firstElm[0];
	}

	function isAnyPartOfElementInViewport(el) {

		const rect = el.getBoundingClientRect();
		// DOMRect { x: 8, y: 8, width: 100, height: 100, top: 8, right: 108, bottom: 108, left: 8 }
		const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
		const windowWidth = (window.innerWidth || document.documentElement.clientWidth);

		// http://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
		const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
		const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

		return (vertInView && horInView);
	}


	return {
		'get_arr': get_arr,
		'get_first_from': get_first,
		'isAnyPartOfElementInViewport': isAnyPartOfElementInViewport
	}

})();


class Utils {  
  debounce (fn, time) {
    let timeout;
  
    return function() {
      const functionCall = () => fn.apply(this, arguments);
      
      clearTimeout(timeout);
      timeout = setTimeout(functionCall, time);
    };
  }

  throttle (func, limit) {
    let lastFunc;
    let lastRan;
    return () => {
      const context = this;
      const args = arguments;
      if (!lastRan) {
        func.apply(context, args);
        lastRan = Date.now();
      } else {
        clearTimeout(lastFunc);
        lastFunc = setTimeout(() => {
          if ((Date.now() - lastRan) >= limit) {
            func.apply(context, args);
            lastRan = Date.now();
          }
        }, limit - (Date.now() - lastRan));
      }
    };
  }

  triggerEvent(el, eventName, options) {
    let event;
    let opt = options;
    if (!opt) {
      opt = {
        detail: {
          message: "Custom Event",
          time: new Date()
        },
        bubbles: true,
        cancelable: true
      };
    }
		if (window.CustomEvent && typeof window.CustomEvent === "function") {
			event = new window.CustomEvent(eventName, opt);
		} else {
			event = document.createEvent('CustomEvent');
			event.initCustomEvent(eventName, true, true, opt);
		}
		el.dispatchEvent(event);
	}

  select (sizzle, parent) {
    if (!(typeof sizzle === 'string' || sizzle instanceof String)) {
      console.log('Problem: esriClientUtils.select() requires that the sizzle value passed in is a string.');
      return null;
    } else {
      let elem;
      if (parent) {
        elem = parent.querySelector(sizzle);
      } else {
        elem = document.querySelector(sizzle);
      }
    
      return elem;
    }
  }

  selectAll (sizzle, parent) {
    if (!(typeof sizzle === 'string' || sizzle instanceof String)) {
      console.log('Problem: esriClientUtils.selectAll() requires that the sizzle value passed in is a string.');
      return [];
    } else {
      let elems;
      if (parent) {
        elems = parent.querySelectorAll(sizzle);
      } else {
        elems = document.querySelectorAll(sizzle);
      }

      return [].slice.call(elems);
    }
  }

  findAncestor (el, cls) {
    let elem = el;
    while ((elem = elem.parentElement) && !elem.classList.contains(cls));
    return elem;
  }
  
  getOffset (el) {
    const rect = el.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return {top: rect.top + scrollTop, left: rect.left + scrollLeft};
  }
  
  fadeOut (el, callback) {
    let op = 1;  // initial opacity
    const timer = window.setInterval(() => {
        if (op <= 0.1) {
            window.clearInterval(timer);
            el.style.display = 'none';
            if (callback) {
              callback();
            }
        }
        el.style.opacity = op;
        el.style.filter = `alpha(opacity=${op * 100})`;
        op -= op * 0.1;
    }, 10);
  }
};

// export const utils = new Utils();
// export default utils;
window.esriClientUtils = new Utils(); 
 
'use strict';

function run_view_more() {
	if (fed_powers) {

		// get view more container
		var viewMoreParent = fed_powers.get_arr('[data-view-more="parent"]');
		if (viewMoreParent.length > 0) {
			var hasColumnMultiplier = parseInt(viewMoreParent[0].dataset.columnMultiplier);
		}
		var targets = fed_powers.get_arr('[data-view-more="parent"] > *'),
			viewMoreLink = fed_powers.get_first_from('h3 .view-more'),
			viewMoreWrapper = fed_powers.get_first_from('.nr-view-more'),
			searchForm = fed_powers.get_first_from('.end-view-more'),
			searchInput = fed_powers.get_first_from('.nr-bottom-search .n-gateway-search-control');

		if (viewMoreLink) {

			var add_view_more_btn = function () {
				viewMoreLink.classList.add('active');
				viewMoreLink.addEventListener('click', show_next_round, false);
			};

			var show_next_round = function () {
				viewMoreWrapper.style.opacity = 0;
				var notActive = fed_powers.get_arr('[data-view-more="parent"] > [aria-hidden="true"]');
				let multiplier = hasColumnMultiplier ? hasColumnMultiplier : 6;
				var nextToShow = notActive.splice(0, multiplier);
				nextToShow.forEach(function (target) {
					target.setAttribute('aria-hidden', 'false');
					target.setAttribute('tabIndex', '1');
					target.classList.add('fade-up');
				});

				// show search form and if shown 24 or shown all available
				var activeItems = fed_powers.get_arr('[data-view-more="parent"] > [aria-hidden="false"]');
				// rerun, need new count after last iteration.
				var hiddenRecount = fed_powers.get_arr('[data-view-more="parent"] > [aria-hidden="true"]');
				if (activeItems.length == 24 && hiddenRecount.length > 0) {
					viewMoreLink.classList.remove('active');
					searchForm.classList.add('active');
				} else if (hiddenRecount.length === 0) {
					viewMoreLink.classList.remove('active');
					searchForm.classList.add('active');
				}

				// prevent seeing btn change...I know, is embarrassing - but simple.
				setTimeout(function () {
					viewMoreWrapper.style.opacity = 1;
				}, 500);
			};

			// Remove custom label on "Still Looking" form 2

			var replace_searchField_tag = function () {
				[].forEach.call(searchForm.querySelectorAll('[data-search-tag]'), function (tag) {
					var tagString = tag.getAttribute('data-search-tag');
					var searchLabel = tag.querySelector('.n-gateway-search-label');
					searchLabel.innerHTML = tagString;
				});
			};
			replace_searchField_tag();

			// how many targets
			if (viewMoreParent && viewMoreParent.length === 1) {
				if (Array.isArray(targets)) {
					var targetsCount = targets.length;

					if (targetsCount < 11) {
						targets.forEach(function (target) {
							target.setAttribute('aria-hidden', 'false');
						});
					} else if (targetsCount > 10 && targetsCount < 16) {
						let multiplier = hasColumnMultiplier ? (hasColumnMultiplier * 3) : (3 * 3);
						var firstAct = targets.slice(0, multiplier);
						firstAct.forEach(function (target) {
							target.setAttribute('aria-hidden', 'false');
						});

						add_view_more_btn();
					} else if (targetsCount >= 16) {
						let multiplier = hasColumnMultiplier ? (hasColumnMultiplier * 4) : (3 * 4);
						var _firstAct = targets.slice(0, multiplier);
						_firstAct.forEach(function (target) {
							target.setAttribute('aria-hidden', 'false');
						});

						add_view_more_btn();
					}
				}
			} else {
				// TODO: will extend here when there is the need for more than one "view more" pare page
			}

			if (searchInput) {

			}

		}	// end of test viewMoreLink

	}
}



//# sourceMappingURL=view_more.js.map

// publication pages - can have only 3 cards

document.addEventListener("DOMContentLoaded", function (event) {
	let viewMoreSections = fed_powers.get_arr('.newsr-cards');

	if (viewMoreSections.length > 0) {
		viewMoreSections.forEach((section) => {
			let cards = [].slice.call(section.querySelectorAll('.newsr-card'));
			let thisViewMore = section.querySelector('.nr-view-more');
			if (cards.length < 4) {
				thisViewMore.style.display = 'none';
			}
		})
	}
});

/*  v.xcvxcsd */
// has a dependency on fed_powers




document.addEventListener("DOMContentLoaded", function(event) {
	var showSummaryLinks = fed_powers.get_arr( '[data-show-summary]' );
	toggleShowSummary(showSummaryLinks, "add");

	var hideSummaryLinks = fed_powers.get_arr( '[data-hide-summary]' );
	toggleShowSummary(hideSummaryLinks, "remove");

	function toggleShowSummary(linkArr, action){
		if(linkArr.length > 0) {
			linkArr.forEach(function(showlink){
				showlink.addEventListener("click", function (e) {
					e.stopPropagation();
					this.parentNode.parentNode.classList[action]('show-summary');
				});
			})
		}

	}

});

/*!
 * clipboard.js v1.7.1
 * https://zenorocha.github.io/clipboard.js
 *
 * Licensed MIT © Zeno Rocha
 */
!function(t){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,e.Clipboard=t()}}(function(){var t,e,n;return function t(e,n,o){function i(a,c){if(!n[a]){if(!e[a]){var l="function"==typeof require&&require;if(!c&&l)return l(a,!0);if(r)return r(a,!0);var s=new Error("Cannot find module '"+a+"'");throw s.code="MODULE_NOT_FOUND",s}var u=n[a]={exports:{}};e[a][0].call(u.exports,function(t){var n=e[a][1][t];return i(n||t)},u,u.exports,t,e,n,o)}return n[a].exports}for(var r="function"==typeof require&&require,a=0;a<o.length;a++)i(o[a]);return i}({1:[function(t,e,n){function o(t,e){for(;t&&t.nodeType!==i;){if("function"==typeof t.matches&&t.matches(e))return t;t=t.parentNode}}var i=9;if("undefined"!=typeof Element&&!Element.prototype.matches){var r=Element.prototype;r.matches=r.matchesSelector||r.mozMatchesSelector||r.msMatchesSelector||r.oMatchesSelector||r.webkitMatchesSelector}e.exports=o},{}],2:[function(t,e,n){function o(t,e,n,o,r){var a=i.apply(this,arguments);return t.addEventListener(n,a,r),{destroy:function(){t.removeEventListener(n,a,r)}}}function i(t,e,n,o){return function(n){n.delegateTarget=r(n.target,e),n.delegateTarget&&o.call(t,n)}}var r=t("./closest");e.exports=o},{"./closest":1}],3:[function(t,e,n){n.node=function(t){return void 0!==t&&t instanceof HTMLElement&&1===t.nodeType},n.nodeList=function(t){var e=Object.prototype.toString.call(t);return void 0!==t&&("[object NodeList]"===e||"[object HTMLCollection]"===e)&&"length"in t&&(0===t.length||n.node(t[0]))},n.string=function(t){return"string"==typeof t||t instanceof String},n.fn=function(t){return"[object Function]"===Object.prototype.toString.call(t)}},{}],4:[function(t,e,n){function o(t,e,n){if(!t&&!e&&!n)throw new Error("Missing required arguments");if(!c.string(e))throw new TypeError("Second argument must be a String");if(!c.fn(n))throw new TypeError("Third argument must be a Function");if(c.node(t))return i(t,e,n);if(c.nodeList(t))return r(t,e,n);if(c.string(t))return a(t,e,n);throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList")}function i(t,e,n){return t.addEventListener(e,n),{destroy:function(){t.removeEventListener(e,n)}}}function r(t,e,n){return Array.prototype.forEach.call(t,function(t){t.addEventListener(e,n)}),{destroy:function(){Array.prototype.forEach.call(t,function(t){t.removeEventListener(e,n)})}}}function a(t,e,n){return l(document.body,t,e,n)}var c=t("./is"),l=t("delegate");e.exports=o},{"./is":3,delegate:2}],5:[function(t,e,n){function o(t){var e;if("SELECT"===t.nodeName)t.focus(),e=t.value;else if("INPUT"===t.nodeName||"TEXTAREA"===t.nodeName){var n=t.hasAttribute("readonly");n||t.setAttribute("readonly",""),t.select(),t.setSelectionRange(0,t.value.length),n||t.removeAttribute("readonly"),e=t.value}else{t.hasAttribute("contenteditable")&&t.focus();var o=window.getSelection(),i=document.createRange();i.selectNodeContents(t),o.removeAllRanges(),o.addRange(i),e=o.toString()}return e}e.exports=o},{}],6:[function(t,e,n){function o(){}o.prototype={on:function(t,e,n){var o=this.e||(this.e={});return(o[t]||(o[t]=[])).push({fn:e,ctx:n}),this},once:function(t,e,n){function o(){i.off(t,o),e.apply(n,arguments)}var i=this;return o._=e,this.on(t,o,n)},emit:function(t){var e=[].slice.call(arguments,1),n=((this.e||(this.e={}))[t]||[]).slice(),o=0,i=n.length;for(o;o<i;o++)n[o].fn.apply(n[o].ctx,e);return this},off:function(t,e){var n=this.e||(this.e={}),o=n[t],i=[];if(o&&e)for(var r=0,a=o.length;r<a;r++)o[r].fn!==e&&o[r].fn._!==e&&i.push(o[r]);return i.length?n[t]=i:delete n[t],this}},e.exports=o},{}],7:[function(e,n,o){!function(i,r){if("function"==typeof t&&t.amd)t(["module","select"],r);else if(void 0!==o)r(n,e("select"));else{var a={exports:{}};r(a,i.select),i.clipboardAction=a.exports}}(this,function(t,e){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var i=n(e),r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},a=function(){function t(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(e,n,o){return n&&t(e.prototype,n),o&&t(e,o),e}}(),c=function(){function t(e){o(this,t),this.resolveOptions(e),this.initSelection()}return a(t,[{key:"resolveOptions",value:function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.action=e.action,this.container=e.container,this.emitter=e.emitter,this.target=e.target,this.text=e.text,this.trigger=e.trigger,this.selectedText=""}},{key:"initSelection",value:function t(){this.text?this.selectFake():this.target&&this.selectTarget()}},{key:"selectFake",value:function t(){var e=this,n="rtl"==document.documentElement.getAttribute("dir");this.removeFake(),this.fakeHandlerCallback=function(){return e.removeFake()},this.fakeHandler=this.container.addEventListener("click",this.fakeHandlerCallback)||!0,this.fakeElem=document.createElement("textarea"),this.fakeElem.style.fontSize="12pt",this.fakeElem.style.border="0",this.fakeElem.style.padding="0",this.fakeElem.style.margin="0",this.fakeElem.style.position="absolute",this.fakeElem.style[n?"right":"left"]="-9999px";var o=window.pageYOffset||document.documentElement.scrollTop;this.fakeElem.style.top=o+"px",this.fakeElem.setAttribute("readonly",""),this.fakeElem.value=this.text,this.container.appendChild(this.fakeElem),this.selectedText=(0,i.default)(this.fakeElem),this.copyText()}},{key:"removeFake",value:function t(){this.fakeHandler&&(this.container.removeEventListener("click",this.fakeHandlerCallback),this.fakeHandler=null,this.fakeHandlerCallback=null),this.fakeElem&&(this.container.removeChild(this.fakeElem),this.fakeElem=null)}},{key:"selectTarget",value:function t(){this.selectedText=(0,i.default)(this.target),this.copyText()}},{key:"copyText",value:function t(){var e=void 0;try{e=document.execCommand(this.action)}catch(t){e=!1}this.handleResult(e)}},{key:"handleResult",value:function t(e){this.emitter.emit(e?"success":"error",{action:this.action,text:this.selectedText,trigger:this.trigger,clearSelection:this.clearSelection.bind(this)})}},{key:"clearSelection",value:function t(){this.trigger&&this.trigger.focus(),window.getSelection().removeAllRanges()}},{key:"destroy",value:function t(){this.removeFake()}},{key:"action",set:function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"copy";if(this._action=e,"copy"!==this._action&&"cut"!==this._action)throw new Error('Invalid "action" value, use either "copy" or "cut"')},get:function t(){return this._action}},{key:"target",set:function t(e){if(void 0!==e){if(!e||"object"!==(void 0===e?"undefined":r(e))||1!==e.nodeType)throw new Error('Invalid "target" value, use a valid Element');if("copy"===this.action&&e.hasAttribute("disabled"))throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');if("cut"===this.action&&(e.hasAttribute("readonly")||e.hasAttribute("disabled")))throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');this._target=e}},get:function t(){return this._target}}]),t}();t.exports=c})},{select:5}],8:[function(e,n,o){!function(i,r){if("function"==typeof t&&t.amd)t(["module","./clipboard-action","tiny-emitter","good-listener"],r);else if(void 0!==o)r(n,e("./clipboard-action"),e("tiny-emitter"),e("good-listener"));else{var a={exports:{}};r(a,i.clipboardAction,i.tinyEmitter,i.goodListener),i.clipboard=a.exports}}(this,function(t,e,n,o){"use strict";function i(t){return t&&t.__esModule?t:{default:t}}function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function a(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function c(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function l(t,e){var n="data-clipboard-"+t;if(e.hasAttribute(n))return e.getAttribute(n)}var s=i(e),u=i(n),f=i(o),d="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},h=function(){function t(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(e,n,o){return n&&t(e.prototype,n),o&&t(e,o),e}}(),p=function(t){function e(t,n){r(this,e);var o=a(this,(e.__proto__||Object.getPrototypeOf(e)).call(this));return o.resolveOptions(n),o.listenClick(t),o}return c(e,t),h(e,[{key:"resolveOptions",value:function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.action="function"==typeof e.action?e.action:this.defaultAction,this.target="function"==typeof e.target?e.target:this.defaultTarget,this.text="function"==typeof e.text?e.text:this.defaultText,this.container="object"===d(e.container)?e.container:document.body}},{key:"listenClick",value:function t(e){var n=this;this.listener=(0,f.default)(e,"click",function(t){return n.onClick(t)})}},{key:"onClick",value:function t(e){var n=e.delegateTarget||e.currentTarget;this.clipboardAction&&(this.clipboardAction=null),this.clipboardAction=new s.default({action:this.action(n),target:this.target(n),text:this.text(n),container:this.container,trigger:n,emitter:this})}},{key:"defaultAction",value:function t(e){return l("action",e)}},{key:"defaultTarget",value:function t(e){var n=l("target",e);if(n)return document.querySelector(n)}},{key:"defaultText",value:function t(e){return l("text",e)}},{key:"destroy",value:function t(){this.listener.destroy(),this.clipboardAction&&(this.clipboardAction.destroy(),this.clipboardAction=null)}}],[{key:"isSupported",value:function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:["copy","cut"],n="string"==typeof e?[e]:e,o=!!document.queryCommandSupported;return n.forEach(function(t){o=o&&!!document.queryCommandSupported(t)}),o}}]),e}(u.default);t.exports=p})},{"./clipboard-action":7,"good-listener":4,"tiny-emitter":6}]},{},[8])(8)});
const syncCardsHeight = (noImgCardArr, normalCardArr) => {
	let allCards = noImgCardArr.concat(normalCardArr);
	const removeStyles = () => allCards.forEach(card => card.removeAttribute("style"));

	const getTallestCardHeight = () => {
		let startingHeight = 0;
		allCards.forEach(card => {
			let cardH = card.offsetHeight;
			cardH > startingHeight ? startingHeight = cardH : null;
		});
		return startingHeight;
	};

	// operation
	const adjustHeight = () => {
		let heightCard = getTallestCardHeight();
		allCards.forEach(card => card.style.height = `${heightCard}px`);
	};

	window.addEventListener('resize', () => {
		// adjust height only on desktop
		if(window.innerWidth > 860 ){
			adjustHeight();
		} else {
			removeStyles();
		}
	});

	// adjust height if needed onload
	if(window.innerWidth > 860 ){
		adjustHeight();
	}

};

document.addEventListener("DOMContentLoaded", function(event) {
	// Search for cards
	const noImgCardArr = [].slice.call(document.querySelectorAll('.newsr-card.no-figure'));
	const normalCardArr = [].slice.call(document.querySelectorAll('.newsr-card:not(.no-figure)'));
	// check to see if imageless cards are present
	if (noImgCardArr.length > 0 ){
		syncCardsHeight(noImgCardArr, normalCardArr);
	}
});

/* v.11.03.21 */


/**
 * Created by jorg8918 on 3/10/18.
 */

	let boundedSticky = (function() {

		let stickyTarget = document.querySelector('[data-sticky="target"]');
	    if(stickyTarget) {
			let settings = {};
			let paddingTop = null;
			let paddingbottom = null;
			let topOffset = null;
			let step = 'off';
			let topBoundry = document.querySelector('[data-sticky-boundry="top"]');
			let bottomBoundry = document.querySelector('[data-sticky-boundry="bottom"]');

			let stickyTargetH = stickyTarget.offsetHeight;
			let setSettings = function(settings){
				paddingTop = settings.paddingTop;
				paddingbottom = settings.paddingBottom;
				topOffset = settings.minTopOffset;
			}
			let docHeight = document.documentElement.scrollHeight;

			function init(){
				topBoundry = document.querySelector('[data-sticky-boundry="top"]');
				bottomBoundry = document.querySelector('[data-sticky-boundry="bottom"]');
				stickyTarget = document.querySelector('[data-sticky="target"]');
				stickyTargetH = stickyTarget.offsetHeight;
				docHeight = document.documentElement.scrollHeight;
			}

			function fixedToAbsolute(){
				stickyTarget.classList.add('fixed');
				stickyTarget.classList.remove('absolute');
				step ='off';
			}
			function absoluteToFixed(){
				stickyTarget.classList.add('absolute');
				stickyTarget.classList.remove('fixed');
				step ='off';
			}

			function topOperations() {
				var isfixed = topBoundry.getBoundingClientRect().bottom < 0;
				if (isfixed) {
					fixedToAbsolute()
					if(stickyTarget.getAttribute('style')){
						stickyTarget.removeAttribute('style')
					}
				} else {
					if(! stickyTarget.getAttribute('style')){
						topOffset = topBoundry.offsetTop >= topOffset ? topBoundry.offsetTop : topOffset; /* accounts for nav even if it has not being downloaded yet */
						stickyTarget.style.top = (topOffset + topBoundry.offsetHeight + paddingTop) + 'px';
					}
					absoluteToFixed()
				}
			}
			function bottomOperations(){
				var isAbsolute = bottomBoundry.getBoundingClientRect().top  < 120 + stickyTargetH ;
				if (isAbsolute){
					absoluteToFixed();
					if(! stickyTarget.getAttribute('style')){
						stickyTarget.style.top = bottomBoundry.offsetTop - (stickyTargetH + paddingbottom) + 'px';
					}
				} else {
					if(stickyTarget.getAttribute('style')){
						stickyTarget.removeAttribute('style')
					}
					fixedToAbsolute()
				}
			}
			function setOperation(){
				(docHeight/2) > window.pageYOffset ? topOperations() : bottomOperations();
			}

			function initScrollWatcher(currentSettings){
				setSettings(currentSettings);
				setOperation();

				window.addEventListener('scroll', function (){

					if (step === 'off'){
						setTimeout(function(){
							step = 'on';
							setOperation();
						}, 100);
					}
				})

				window.addEventListener('resize', function () {
					init();
					stickyTarget.style.top =  (topBoundry.offsetTop + topBoundry.offsetHeight + paddingTop) + 'px';
				})
			}

			return {
				init: init,
				initScrollWatcher : initScrollWatcher
			}
		}
	}());


/* v.fdr */

/*
 Yaku v0.17.9
 (c) 2015 Yad Smood. http://ysmood.org
 License MIT
 */
(function () {
  "use strict";

  var $undefined
    , $null = null
    , isBrowser = typeof window === "object"
    , root = isBrowser ? window : global
    , nativePromise = root.Promise
    , process = root.process
    , console = root.console
    , isLongStackTrace = false
    , Arr = Array
    , Err = Error

    , $rejected = 1
    , $resolved = 2
    , $pending = 3

    , $Symbol = "Symbol"
    , $iterator = "iterator"
    , $species = "species"
    , $speciesKey = $Symbol + "(" + $species + ")"
    , $return = "return"

    , $unhandled = "_uh"
    , $promiseTrace = "_pt"
    , $settlerTrace = "_st"

    , $invalidThis = "Invalid this"
    , $invalidArgument = "Invalid argument"
    , $fromPrevious = "\nFrom previous "
    , $promiseCircularChain = "Chaining cycle detected for promise"
    , $unhandledRejectionMsg = "Uncaught (in promise)"
    , $rejectionHandled = "rejectionHandled"
    , $unhandledRejection = "unhandledRejection"

    , $tryCatchFn
    , $tryCatchThis
    , $tryErr = { e: $null }
    , $noop = function () { }
    , $cleanStackReg = /^.+\/node_modules\/yaku\/.+\n?/mg
    ;

  /**
   * This class follows the [Promises/A+](https://promisesaplus.com) and
   * [ES6](http://people.mozilla.org/~jorendorff/es6-draft.html#sec-promise-objects) spec
   * with some extra helpers.
   * @param  {Function} executor Function object with two arguments resolve, reject.
   * The first argument fulfills the promise, the second argument rejects it.
   * We can call these functions, once our operation is completed.
   */
  var Yaku = function (executor) {
    var self = this,
      err;

    // "this._s" is the internao state of: pending, resolved or rejected
    // "this._v" is the internal value

    if (!isObject(self) || self._s !== $undefined)
      throw genTypeError($invalidThis);

    self._s = $pending;

    if (isLongStackTrace) self[$promiseTrace] = genTraceInfo();

    if (executor !== $noop) {
      if (!isFunction(executor))
        throw genTypeError($invalidArgument);

      err = genTryCatcher(executor)(
        genSettler(self, $resolved),
        genSettler(self, $rejected)
      );

      if (err === $tryErr)
        settlePromise(self, $rejected, err.e);
    }
  };

  Yaku["default"] = Yaku;

  extend(Yaku.prototype, {
    /**
     * Appends fulfillment and rejection handlers to the promise,
     * and returns a new promise resolving to the return value of the called handler.
     * @param  {Function} onFulfilled Optional. Called when the Promise is resolved.
     * @param  {Function} onRejected  Optional. Called when the Promise is rejected.
     * @return {Yaku} It will return a new Yaku which will resolve or reject after
     * @example
     * the current Promise.
     * ```js
     * var Promise = require('yaku');
     * var p = Promise.resolve(10);
     *
     * p.then((v) => {
         *     console.log(v);
         * });
     * ```
     */
    then: function (onFulfilled, onRejected) {
      if (this._s === undefined) throw genTypeError();

      return addHandler(
        this,
        newCapablePromise(Yaku.speciesConstructor(this, Yaku)),
        onFulfilled,
        onRejected
      );
    },

    /**
     * The `catch()` method returns a Promise and deals with rejected cases only.
     * It behaves the same as calling `Promise.prototype.then(undefined, onRejected)`.
     * @param  {Function} onRejected A Function called when the Promise is rejected.
     * This function has one argument, the rejection reason.
     * @return {Yaku} A Promise that deals with rejected cases only.
     * @example
     * ```js
     * var Promise = require('yaku');
     * var p = Promise.reject(new Error("ERR"));
     *
     * p['catch']((v) => {
         *     console.log(v);
         * });
     * ```
     */
    "catch": function (onRejected) {
      return this.then($undefined, onRejected);
    },

    /**
     * Register a callback to be invoked when a promise is settled (either fulfilled or rejected).
     * Similar with the try-catch-finally, it's often used for cleanup.
     * @param  {Function} onFinally A Function called when the Promise is settled.
     * It will not receive any argument.
     * @return {Yaku} A Promise that will reject if onFinally throws an error or returns a rejected promise.
     * Else it will resolve previous promise's final state (either fulfilled or rejected).
     * @example
     * ```js
     * var Promise = require('yaku');
     * var p = Math.random() > 0.5 ? Promise.resolve() : Promise.reject();
     * p.finally(() => {
         *     console.log('finally');
         * });
     * ```
     */
    "finally": function (onFinally) {
      return this.then(function (val) {
        return Yaku.resolve(onFinally()).then(function () {
          return val;
        });
      }, function (err) {
        return Yaku.resolve(onFinally()).then(function () {
          throw err;
        });
      });
    },

    // The number of current promises that attach to this Yaku instance.
    _c: 0,

    // The parent Yaku.
    _p: $null
  });

  /**
   * The `Promise.resolve(value)` method returns a Promise object that is resolved with the given value.
   * If the value is a thenable (i.e. has a then method), the returned promise will "follow" that thenable,
   * adopting its eventual state; otherwise the returned promise will be fulfilled with the value.
   * @param  {Any} value Argument to be resolved by this Promise.
   * Can also be a Promise or a thenable to resolve.
   * @return {Yaku}
   * @example
   * ```js
   * var Promise = require('yaku');
   * var p = Promise.resolve(10);
   * ```
   */
  Yaku.resolve = function (val) {
    return isYaku(val) ? val : settleWithX(newCapablePromise(this), val);
  };

  /**
   * The `Promise.reject(reason)` method returns a Promise object that is rejected with the given reason.
   * @param  {Any} reason Reason why this Promise rejected.
   * @return {Yaku}
   * @example
   * ```js
   * var Promise = require('yaku');
   * var p = Promise.reject(new Error("ERR"));
   * ```
   */
  Yaku.reject = function (reason) {
    return settlePromise(newCapablePromise(this), $rejected, reason);
  };

  /**
   * The `Promise.race(iterable)` method returns a promise that resolves or rejects
   * as soon as one of the promises in the iterable resolves or rejects,
   * with the value or reason from that promise.
   * @param  {iterable} iterable An iterable object, such as an Array.
   * @return {Yaku} The race function returns a Promise that is settled
   * the same way as the first passed promise to settle.
   * It resolves or rejects, whichever happens first.
   * @example
   * ```js
   * var Promise = require('yaku');
   * Promise.race([
   *     123,
   *     Promise.resolve(0)
   * ])
   * .then((value) => {
     *     console.log(value); // => 123
     * });
   * ```
   */
  Yaku.race = function (iterable) {
    var self = this
      , p = newCapablePromise(self)

      , resolve = function (val) {
        settlePromise(p, $resolved, val);
      }

      , reject = function (val) {
        settlePromise(p, $rejected, val);
      }

      , ret = genTryCatcher(each)(iterable, function (v) {
        self.resolve(v).then(resolve, reject);
      });

    if (ret === $tryErr) return self.reject(ret.e);

    return p;
  };

  /**
   * The `Promise.all(iterable)` method returns a promise that resolves when
   * all of the promises in the iterable argument have resolved.
   *
   * The result is passed as an array of values from all the promises.
   * If something passed in the iterable array is not a promise,
   * it's converted to one by Promise.resolve. If any of the passed in promises rejects,
   * the all Promise immediately rejects with the value of the promise that rejected,
   * discarding all the other promises whether or not they have resolved.
   * @param  {iterable} iterable An iterable object, such as an Array.
   * @return {Yaku}
   * @example
   * ```js
   * var Promise = require('yaku');
   * Promise.all([
   *     123,
   *     Promise.resolve(0)
   * ])
   * .then((values) => {
     *     console.log(values); // => [123, 0]
     * });
   * ```
   * @example
   * Use with iterable.
   * ```js
   * var Promise = require('yaku');
   * Promise.all((function * () {
     *     yield 10;
     *     yield new Promise(function (r) { setTimeout(r, 1000, "OK") });
     * })())
   * .then((values) => {
     *     console.log(values); // => [123, 0]
     * });
   * ```
   */
  Yaku.all = function (iterable) {
    var self = this
      , p1 = newCapablePromise(self)
      , res = []
      , ret
      ;

    function reject(reason) {
      settlePromise(p1, $rejected, reason);
    }

    ret = genTryCatcher(each)(iterable, function (item, i) {
      self.resolve(item).then(function (value) {
        res[i] = value;
        if (!--ret) settlePromise(p1, $resolved, res);
      }, reject);
    });

    if (ret === $tryErr) return self.reject(ret.e);

    if (!ret) settlePromise(p1, $resolved, []);

    return p1;
  };

  /**
   * The ES6 Symbol object that Yaku should use, by default it will use the
   * global one.
   * @type {Object}
   * @example
   * ```js
   * var core = require("core-js/library");
   * var Promise = require("yaku");
   * Promise.Symbol = core.Symbol;
   * ```
   */
  Yaku.Symbol = root[$Symbol] || {};

  // To support browsers that don't support `Object.defineProperty`.
  genTryCatcher(function () {
    Object.defineProperty(Yaku, getSpecies(), {
      get: function () { return this; }
    });
  })();

  /**
   * Use this api to custom the species behavior.
   * https://tc39.github.io/ecma262/#sec-speciesconstructor
   * @param {Any} O The current this object.
   * @param {Function} defaultConstructor
   */
  Yaku.speciesConstructor = function (O, D) {
    var C = O.constructor;

    return C ? (C[getSpecies()] || D) : D;
  };

  /**
   * Catch all possibly unhandled rejections. If you want to use specific
   * format to display the error stack, overwrite it.
   * If it is set, auto `console.error` unhandled rejection will be disabled.
   * @param {Any} reason The rejection reason.
   * @param {Yaku} p The promise that was rejected.
   * @example
   * ```js
   * var Promise = require('yaku');
   * Promise.unhandledRejection = (reason) => {
     *     console.error(reason);
     * };
   *
   * // The console will log an unhandled rejection error message.
   * Promise.reject('my reason');
   *
   * // The below won't log the unhandled rejection error message.
   * Promise.reject('v')["catch"](() => {});
   * ```
   */
  Yaku.unhandledRejection = function (reason, p) {
    console && console.error(
      $unhandledRejectionMsg,
      isLongStackTrace ? p.longStack : genStackInfo(reason, p)
    );
  };

  /**
   * Emitted whenever a Promise was rejected and an error handler was
   * attached to it (for example with `["catch"]()`) later than after an event loop turn.
   * @param {Any} reason The rejection reason.
   * @param {Yaku} p The promise that was rejected.
   */
  Yaku.rejectionHandled = $noop;

  /**
   * It is used to enable the long stack trace.
   * Once it is enabled, it can't be reverted.
   * While it is very helpful in development and testing environments,
   * it is not recommended to use it in production. It will slow down
   * application and eat up memory.
   * It will add an extra property `longStack` to the Error object.
   * @example
   * ```js
   * var Promise = require('yaku');
   * Promise.enableLongStackTrace();
   * Promise.reject(new Error("err"))["catch"]((err) => {
     *     console.log(err.longStack);
     * });
   * ```
   */
  Yaku.enableLongStackTrace = function () {
    isLongStackTrace = true;
  };

  /**
   * Only Node has `process.nextTick` function. For browser there are
   * so many ways to polyfill it. Yaku won't do it for you, instead you
   * can choose what you prefer. For example, this project
   * [next-tick](https://github.com/medikoo/next-tick).
   * By default, Yaku will use `process.nextTick` on Node, `setTimeout` on browser.
   * @type {Function}
   * @example
   * ```js
   * var Promise = require('yaku');
   * Promise.nextTick = require('next-tick');
   * ```
   * @example
   * You can even use sync resolution if you really know what you are doing.
   * ```js
   * var Promise = require('yaku');
   * Promise.nextTick = fn => fn();
   * ```
   */
  Yaku.nextTick = isBrowser ?
    function (fn) {
      nativePromise ?
        new nativePromise(function (resolve) { resolve(); }).then(fn) :
        setTimeout(fn);
    } :
    process.nextTick;

  // ********************** Private **********************

  Yaku._s = 1;

  /**
   * All static variable name will begin with `$`. Such as `$rejected`.
   * @private
   */

  // ******************************* Utils ********************************

  function getSpecies() {
    return Yaku[$Symbol][$species] || $speciesKey;
  }

  function extend(src, target) {
    for (var k in target) {
      src[k] = target[k];
    }
  }

  function isObject(obj) {
    return obj && typeof obj === "object";
  }

  function isFunction(obj) {
    return typeof obj === "function";
  }

  function isInstanceOf(a, b) {
    return a instanceof b;
  }

  function isError(obj) {
    return isInstanceOf(obj, Err);
  }

  function ensureType(obj, fn, msg) {
    if (!fn(obj)) throw genTypeError(msg);
  }

  /**
   * Wrap a function into a try-catch.
   * @private
   * @return {Any | $tryErr}
   */
  function tryCatcher() {
    try {
      return $tryCatchFn.apply($tryCatchThis, arguments);
    } catch (e) {
      $tryErr.e = e;
      return $tryErr;
    }
  }

  /**
   * Generate a try-catch wrapped function.
   * @private
   * @param  {Function} fn
   * @return {Function}
   */
  function genTryCatcher(fn, self) {
    $tryCatchFn = fn;
    $tryCatchThis = self;
    return tryCatcher;
  }

  /**
   * Generate a scheduler.
   * @private
   * @param  {Integer}  initQueueSize
   * @param  {Function} fn `(Yaku, Value) ->` The schedule handler.
   * @return {Function} `(Yaku, Value) ->` The scheduler.
   */
  function genScheduler(initQueueSize, fn) {
    /**
     * All async promise will be scheduled in
     * here, so that they can be execute on the next tick.
     * @private
     */
    var fnQueue = Arr(initQueueSize)
      , fnQueueLen = 0;

    /**
     * Run all queued functions.
     * @private
     */
    function flush() {
      var i = 0;
      while (i < fnQueueLen) {
        fn(fnQueue[i], fnQueue[i + 1]);
        fnQueue[i++] = $undefined;
        fnQueue[i++] = $undefined;
      }

      fnQueueLen = 0;
      if (fnQueue.length > initQueueSize) fnQueue.length = initQueueSize;
    }

    return function (v, arg) {
      fnQueue[fnQueueLen++] = v;
      fnQueue[fnQueueLen++] = arg;

      if (fnQueueLen === 2) Yaku.nextTick(flush);
    };
  }

  /**
   * Generate a iterator
   * @param  {Any} obj
   * @private
   * @return {Object || TypeError}
   */
  function each(iterable, fn) {
    var len
      , i = 0
      , iter
      , item
      , ret
      ;

    if (!iterable) throw genTypeError($invalidArgument);

    var gen = iterable[Yaku[$Symbol][$iterator]];
    if (isFunction(gen))
      iter = gen.call(iterable);
    else if (isFunction(iterable.next)) {
      iter = iterable;
    }
    else if (isInstanceOf(iterable, Arr)) {
      len = iterable.length;
      while (i < len) {
        fn(iterable[i], i++);
      }
      return i;
    } else
      throw genTypeError($invalidArgument);

    while (!(item = iter.next()).done) {
      ret = genTryCatcher(fn)(item.value, i++);
      if (ret === $tryErr) {
        isFunction(iter[$return]) && iter[$return]();
        throw ret.e;
      }
    }

    return i;
  }

  /**
   * Generate type error object.
   * @private
   * @param  {String} msg
   * @return {TypeError}
   */
  function genTypeError(msg) {
    return new TypeError(msg);
  }

  function genTraceInfo(noTitle) {
    return (noTitle ? "" : $fromPrevious) + new Err().stack;
  }


  // *************************** Promise Helpers ****************************

  /**
   * Resolve the value returned by onFulfilled or onRejected.
   * @private
   * @param {Yaku} p1
   * @param {Yaku} p2
   */
  var scheduleHandler = genScheduler(999, function (p1, p2) {
    var x, handler;

    // 2.2.2
    // 2.2.3
    handler = p1._s !== $rejected ? p2._onFulfilled : p2._onRejected;

    // 2.2.7.3
    // 2.2.7.4
    if (handler === $undefined) {
      settlePromise(p2, p1._s, p1._v);
      return;
    }

    // 2.2.7.1
    x = genTryCatcher(callHanler)(handler, p1._v);
    if (x === $tryErr) {
      // 2.2.7.2
      settlePromise(p2, $rejected, x.e);
      return;
    }

    settleWithX(p2, x);
  });

  var scheduleUnhandledRejection = genScheduler(9, function (p) {
    if (!hashOnRejected(p)) {
      p[$unhandled] = 1;
      emitEvent($unhandledRejection, p);
    }
  });

  function emitEvent(name, p) {
    var browserEventName = "on" + name.toLowerCase()
      , browserHandler = root[browserEventName];

    if (process && process.listeners(name).length)
      name === $unhandledRejection ?
        process.emit(name, p._v, p) : process.emit(name, p);
    else if (browserHandler)
      browserHandler({ reason: p._v, promise: p });
    else
      Yaku[name](p._v, p);
  }

  function isYaku(val) { return val && val._s; }

  function newCapablePromise(Constructor) {
    if (isYaku(Constructor)) return new Constructor($noop);

    var p, r, j;
    p = new Constructor(function (resolve, reject) {
      if (p) throw genTypeError();

      r = resolve;
      j = reject;
    });

    ensureType(r, isFunction);
    ensureType(j, isFunction);

    return p;
  }

  /**
   * It will produce a settlePromise function to user.
   * Such as the resolve and reject in this `new Yaku (resolve, reject) ->`.
   * @private
   * @param  {Yaku} self
   * @param  {Integer} state The value is one of `$pending`, `$resolved` or `$rejected`.
   * @return {Function} `(value) -> undefined` A resolve or reject function.
   */
  function genSettler(self, state) {
    var isCalled = false;
    return function (value) {
      if (isCalled) return;
      isCalled = true;

      if (isLongStackTrace)
        self[$settlerTrace] = genTraceInfo(true);

      if (state === $resolved)
        settleWithX(self, value);
      else
        settlePromise(self, state, value);
    };
  }

  /**
   * Link the promise1 to the promise2.
   * @private
   * @param {Yaku} p1
   * @param {Yaku} p2
   * @param {Function} onFulfilled
   * @param {Function} onRejected
   */
  function addHandler(p1, p2, onFulfilled, onRejected) {
    // 2.2.1
    if (isFunction(onFulfilled))
      p2._onFulfilled = onFulfilled;
    if (isFunction(onRejected)) {
      if (p1[$unhandled]) emitEvent($rejectionHandled, p1);

      p2._onRejected = onRejected;
    }

    if (isLongStackTrace) p2._p = p1;
    p1[p1._c++] = p2;

    // 2.2.6
    if (p1._s !== $pending)
      scheduleHandler(p1, p2);

    // 2.2.7
    return p2;
  }

  // iterate tree
  function hashOnRejected(node) {
    // A node shouldn't be checked twice.
    if (node._umark)
      return true;
    else
      node._umark = true;

    var i = 0
      , len = node._c
      , child;

    while (i < len) {
      child = node[i++];
      if (child._onRejected || hashOnRejected(child)) return true;
    }
  }

  function genStackInfo(reason, p) {
    var stackInfo = [];

    function push(trace) {
      return stackInfo.push(trace.replace(/^\s+|\s+$/g, ""));
    }

    if (isLongStackTrace) {
      if (p[$settlerTrace])
        push(p[$settlerTrace]);

      // Hope you guys could understand how the back trace works.
      // We only have to iterate through the tree from the bottom to root.
      (function iter(node) {
        if (node && $promiseTrace in node) {
          iter(node._next);
          push(node[$promiseTrace] + "");
          iter(node._p);
        }
      })(p);
    }

    return (reason && reason.stack ? reason.stack : reason) +
      ("\n" + stackInfo.join("\n")).replace($cleanStackReg, "");
  }

  function callHanler(handler, value) {
    // 2.2.5
    return handler(value);
  }

  /**
   * Resolve or reject a promise.
   * @private
   * @param  {Yaku} p
   * @param  {Integer} state
   * @param  {Any} value
   */
  function settlePromise(p, state, value) {
    var i = 0
      , len = p._c;

    // 2.1.2
    // 2.1.3
    if (p._s === $pending) {
      // 2.1.1.1
      p._s = state;
      p._v = value;

      if (state === $rejected) {
        if (isLongStackTrace && isError(value)) {
          value.longStack = genStackInfo(value, p);
        }

        scheduleUnhandledRejection(p);
      }

      // 2.2.4
      while (i < len) {
        scheduleHandler(p, p[i++]);
      }
    }

    return p;
  }

  /**
   * Resolve or reject promise with value x. The x can also be a thenable.
   * @private
   * @param {Yaku} p
   * @param {Any | Thenable} x A normal value or a thenable.
   */
  function settleWithX(p, x) {
    // 2.3.1
    if (x === p && x) {
      settlePromise(p, $rejected, genTypeError($promiseCircularChain));
      return p;
    }

    // 2.3.2
    // 2.3.3
    if (x !== $null && (isFunction(x) || isObject(x))) {
      // 2.3.2.1
      var xthen = genTryCatcher(getThen)(x);

      if (xthen === $tryErr) {
        // 2.3.3.2
        settlePromise(p, $rejected, xthen.e);
        return p;
      }

      if (isFunction(xthen)) {
        if (isLongStackTrace && isYaku(x))
          p._next = x;

        // Fix https://bugs.chromium.org/p/v8/issues/detail?id=4162
        if (isYaku(x))
          settleXthen(p, x, xthen);
        else
          Yaku.nextTick(function () {
            settleXthen(p, x, xthen);
          });
      } else
        // 2.3.3.4
        settlePromise(p, $resolved, x);
    } else
      // 2.3.4
      settlePromise(p, $resolved, x);

    return p;
  }

  /**
   * Try to get a promise's then method.
   * @private
   * @param  {Thenable} x
   * @return {Function}
   */
  function getThen(x) { return x.then; }

  /**
   * Resolve then with its promise.
   * @private
   * @param  {Yaku} p
   * @param  {Thenable} x
   * @param  {Function} xthen
   */
  function settleXthen(p, x, xthen) {
    // 2.3.3.3
    var err = genTryCatcher(xthen, x)(function (y) {
      // 2.3.3.3.3
      // 2.3.3.3.1
      x && (x = $null, settleWithX(p, y));
    }, function (r) {
      // 2.3.3.3.3
      // 2.3.3.3.2
      x && (x = $null, settlePromise(p, $rejected, r));
    });

    // 2.3.3.3.4.1
    if (err === $tryErr && x) {
      // 2.3.3.3.4.2
      settlePromise(p, $rejected, err.e);
      x = $null;
    }
  }

  try {
    module.exports = Yaku;
  } catch (e) {
    /* istanbul ignore next */
    root.Yaku = Yaku;
  }
})();

const arcgis_search_redirection = (searchInput, submitBtn, searchForm) => {
  let sInput = searchInput[0];
  let btnIcon = submitBtn[0];
  let locPath = location.pathname;
  let locOrigin = location.origin;

  // clean location path;
  let cArr = locPath.split('/');
  let bArr = cArr.filter((item) => (item.length > 0));
  let pathL = bArr.length;
  let $slug = bArr[pathL - 1];


  if (btnIcon) {
    btnIcon.addEventListener('click', function (e) {
      e.preventDefault();
      let prodSlug = '';
      // create query
      let newQuery = '';
      let inputValue = sInput.value;
      let authorTest = RegExp(/^\@/);
      let tagTest = RegExp(/^\#/);

      //has slug
      $slug = $slug === 'overview' ? '' : $slug;

      if ($slug) {
        prodSlug = `&products=${$slug}`;
      }

      if (authorTest.test(inputValue) || tagTest.test(inputValue)) {
        let searchFilter = authorTest.test(inputValue) ? 'author' : 'tag';
        let stringParam = '';
        if (searchFilter === 'author') {
          let resultArr = arcgis_object.authors.filter((author) => {
            let cleanName = inputValue.substr(1);
            if (author.name == cleanName) {
              return author;
            }
          });
          stringParam = resultArr[0]['nice_name'];
        } else if (searchFilter === 'tag') {
          let resultArr = arcgis_object.tags.filter((tag) => {
            let cleanName = inputValue.substr(1);
            if (tag.name == cleanName) {
              return tag;
            }
          });
          stringParam = resultArr[0]['slug'];
        }        

        const searchPathName = searchForm.attr('action');
        window.location.assign(`${locOrigin}${searchPathName}?s=#&${searchFilter}=${stringParam}${prodSlug}`);
      } else {
        // is not filter search
        let escInput = escape(sInput.value);

        const searchPathName = searchForm.attr('action');
        newQuery = `${locOrigin}${searchPathName}?s=#${escInput}${prodSlug}`;
        window.location.assign(`${locOrigin}${searchPathName}?s=#${escInput}${prodSlug}`);
      }


      //window.location.replace(newQuery);
    });
    sInput.addEventListener('keyup', function (e) {
      e.preventDefault();
      // Number 13 is the "Enter" key on the keyboard
      if (event.keyCode === 13) {
        // Trigger the button element with a click
        btnIcon.click();
      }
    });
  }
};

// v.sosew


// https://css-tricks.com/line-clampin/

// Clamp.js
// https://github.com/josephschmitt/Clamp.js

/**
  * TextOverflowClamp.js
  *
  * Updated 2013-05-09 to remove jQuery dependancy.
  * But be careful with webfonts!
  */

// bind function support for older browsers without it
// https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Function/bind
if (!Function.prototype.bind) {
    Function.prototype.bind = function (oThis) {
      if (typeof this !== "function") {
        // closest thing possible to the ECMAScript 5 internal IsCallable function
        throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");
      }
   
      var aArgs = Array.prototype.slice.call(arguments, 1),
          fToBind = this,
          fNOP = function () {},
          fBound = function () {
            return fToBind.apply(this instanceof fNOP && oThis
                                   ? this
                                   : oThis,
                                 aArgs.concat(Array.prototype.slice.call(arguments)));
          };
   
      fNOP.prototype = this.prototype;
      fBound.prototype = new fNOP();
   
      return fBound;
    };
  }
  
  // the actual meat is here
  (function(w, d){
      var clamp, measure, text, lineWidth,
          lineStart, lineCount, wordStart,
          line, lineText, wasNewLine,
      ce = d.createElement.bind(d),
      ctn = d.createTextNode.bind(d);
      
      // measurement element is made a child of the clamped element to get it's style
      measure = ce('span');
    
      (function(s){
          s.position = 'absolute'; // prevent page reflow
          s.whiteSpace = 'pre'; // cross-browser width results
          s.visibility = 'hidden'; // prevent drawing
      })(measure.style);
      
      clamp = function (el, lineClamp) {
      // make sure the element belongs to the document
      if(!el.ownerDocument || !el.ownerDocument === d) return;
          // reset to safe starting values
          lineStart = wordStart = 0;
          lineCount = 1;
          wasNewLine = false; 
          lineWidth = el.clientWidth;
      lineWidth -= parseInt(window.getComputedStyle(el, null).getPropertyValue('padding-left')); //MODIFICATION FOR ELEMENT PADDING
      lineWidth -= parseInt(window.getComputedStyle(el, null).getPropertyValue('padding-right')); //MODIFICATION FOR ELEMENT PADDING
          // get all the text, remove any line changes
          text = (el.textContent || el.innerText).replace(/\n/g, ' ');
          // remove all content
          while(el.firstChild !== null)
              el.removeChild(el.firstChild);
          // add measurement element within so it inherits styles
          el.appendChild(measure);
          // http://ejohn.org/blog/search-and-dont-replace/
          text.replace(/ /g, function(m, pos) {
              // ignore any further processing if we have total lines
        if(lineCount === lineClamp) return;
              // create a text node and place it in the measurement element
              measure.appendChild(ctn(text.substr(lineStart, pos - lineStart)));
              // have we exceeded allowed line width?
              if(lineWidth < measure.clientWidth) {
                  if(wasNewLine) {
                      // we have a long word so it gets a line of it's own
                      lineText = text.substr(lineStart, pos + 1 - lineStart);
                      // next line start position
                      lineStart = pos + 1;
                  } else {
                      // grab the text until this word
                      lineText = text.substr(lineStart, wordStart - lineStart);
                      // next line start position
                      lineStart = wordStart;
                  }
                  // create a line element
                  line = ce('span');
                  // add text to the line element
                  line.appendChild(ctn(lineText));
                  // add the line element to the container
                  el.appendChild(line);
                  // yes, we created a new line
                  wasNewLine = true;
          lineCount++;
              } else {
                  // did not create a new line
                  wasNewLine = false;
              }
              // remember last word start position
              wordStart = pos + 1;
              // clear measurement element
              measure.removeChild(measure.firstChild);
          });
          // remove the measurement element from the container
          el.removeChild(measure);
          // create the last line element
          line = ce('span');
          // give styles required for text-overflow to kick in
          (function(s){
              s.display = 'block';
              s.overflow = 'hidden';
              s.textOverflow = 'ellipsis';
              s.whiteSpace = 'nowrap';
              s.width = '100%';
          })(line.style);
          // add all remaining text to the line element
          line.appendChild(ctn(text.substr(lineStart)));
          // add the line element to the container
          el.appendChild(line);
      }
      w.clamp = clamp;
  })(window, document);
  

/* Instructions
---------------
1. Put an attribute on any element that might have text too long to fit.
2. In that attribute, create an array of rules, in the format below. Create as little or many rules 
   as necessary to make this element perform with more text. 
3. Think of the width key-value pair as a mobile-first media query, such as: @media (min-width: ?)
4. The maxHeight key-value pair defines how tall the element is allowed to grow to before 
   shrinking/collapsing take place.
5. The minFontSize key-value pair defines how small the font can be set to, before the element is 
   clamped with an ellipsis.
6. For elements with FitText logic that are hidden on load (user has to interact with component to 
   display a slide, etc), then trigger the custom event called 'ESRIFitTextShown'. Example:
   utils.triggerEvent(document,'ESRIFitTextShown');


/* Sample Element
-----------------
<p class="sample_element" 
  data-fit-text="[{'minWidth':0, 'maxHeight':80, 'minFontSize':26}, {'minWidth':860, 'maxHeight':80, 'minFontSize':30}"
  data-fit-text-content="Lorem ipsum.">Lorem ipsum.</p>


/* Sample Rules
---------------
[
  { minWidth:0, maxHeight:80, minFontSize:26 }, 
  { minWidth:480, maxHeight:120, minFontSize:30 }
]

*/

document.addEventListener('DOMContentLoaded', () => {
  class FitText {
    constructor() {
      const elements = esriClientUtils.selectAll('[data-fit-text]');

      if (elements && elements.length) {
        this.createFitMe(elements);
      }
    }

    cleanClamp ({fitMe}) {
      fitMe.el.innerText = fitMe.content;
    }

    cleanShrink ({fitMe}) {
      fitMe.el.style.height = 'auto';
      fitMe.el.style.removeProperty('font-size');
    }

    fitText ({fitMe}) {
      if (fitMe.el.offsetHeight > 0) { // if visible
        // First try to shrink, then 'clamp' with elllipsis if necessary.
        const shrinkSuccess = this.applyShrink({fitMe});
        if (!shrinkSuccess) {
          this.applyClamp({fitMe});
        }
      }
    }

    applyShrink ({fitMe}) {
      this.cleanClamp({fitMe});
      this.cleanShrink({fitMe});

      const wW = window.innerWidth;
      let fontSize = parseInt(window.getComputedStyle(fitMe.el).fontSize);
      let maxHeight = 0;
      let minFontSize = 0;
      let shrinkSuccess = true;

      for (const rule of fitMe.rules) {
        if (wW > rule.minWidth) {
          this.cleanShrink({fitMe});
          maxHeight = rule.maxHeight;
          minFontSize = rule.minFontSize;
        }
      }

      while (shrinkSuccess && fitMe.el.scrollHeight > maxHeight) {
        if (fontSize > minFontSize) {
          fontSize -= 1;
          fitMe.el.style.fontSize = `${fontSize}px`;
        } else {
          shrinkSuccess = false;
        }
      }
      
      return shrinkSuccess;
    }
  
    applyClamp ({fitMe}) {
      this.cleanClamp({fitMe});

      const wW = window.innerWidth;
      let maxHeight = 0;

      for (const rule of fitMe.rules) {
        if (wW > rule.minWidth) {
          maxHeight = rule.maxHeight;
        }
      }

      const numLines = this.getNumLines(maxHeight, {fitMe});

      window.clamp(fitMe.el, numLines);
      fitMe.el.classList.add('ellipsis-clamped');
    }

    getRules (el) {
      let rules = el.getAttribute('data-fit-text').replace(/'/g, '\"');
      return JSON.parse(rules);
    }

    getNumLines (maxHeight, {fitMe}) {
      const lineHeight = parseInt(window.getComputedStyle(fitMe.el).lineHeight);
      const padTop = parseInt(window.getComputedStyle(fitMe.el).paddingTop);
      const padBottom = parseInt(window.getComputedStyle(fitMe.el).paddingBottom);
      const numLines = parseInt((maxHeight - padTop - padBottom) / lineHeight);

      return numLines ? numLines : 1;
    }

    createFitMe (elements) {
      elements.forEach((element) => {
        const fitMe = {
          el: element,
          rules: this.getRules(element),
          content: element.innerText
        };

        this.fitText({fitMe});

        const updateLayout = esriClientUtils.debounce((e) => {
          this.fitText({fitMe});
        }, 500);

        window.addEventListener('resize', updateLayout, false);

        fitMe.el.addEventListener('ESRIFitTextShown', () => {
          this.fitText({fitMe});
        });
      });      
    }
  }

  new FitText();
});

(function () {


	window.addEventListener('DOMContentLoaded', function () {
		function Accordion(view){
			if (view) {
				
				let linkArr = esriClientUtils.selectAll('.faq-accordion-item-section',view);
				let sectArr = esriClientUtils.selectAll('.accordion-title',view);
				let openClose = esriClientUtils.select('.show-hide-all',view);
				let textinfo = esriClientUtils.select('.openCloseText',view);
				let allArrow = esriClientUtils.select('.show-hide-caret',view);
				let openCloseAttr = openClose.getAttribute('aria-hidden');

				let hideAll = (link, isFalse) => {
					openClose.setAttribute('aria-hidden', 'false');
					textinfo.innerHTML = "Hide All";
					allArrow.classList.remove('icon-ui-down');
					allArrow.classList.add('icon-ui-up');
					if (isFalse) { 
						link.classList.add('is-active'); 
					}
				}

				let showAll = (link, isTrue) => {
					openClose.setAttribute('aria-hidden', 'true');
					textinfo.innerHTML = "Show All";
					allArrow.classList.remove('icon-ui-up');
					allArrow.classList.add('icon-ui-down');
					if (isTrue) {
						link.classList.remove('is-active');
					}
				}

				sectArr.forEach(el => {
					el.addEventListener('click', (evt) => {
						let sectCount = esriClientUtils.select('.faq-accordion--content',view);
						let sectExpanded = sectCount.querySelectorAll('.faq-accordion-item-section.is-active').length;
						let sectTotal = sectCount.querySelectorAll('.faq-accordion-item-section').length;
						const half = 2;
						
						(sectExpanded > (sectTotal/half)) ? hideAll() : showAll();
						
						openCloseAttr = openClose.getAttribute('aria-hidden');
					
					});
				});
				
			
					openClose.addEventListener('click', function (event) {
						if (openCloseAttr === "true") {
							linkArr.forEach(function (link) { hideAll(link, true) });
						} else if (openCloseAttr === "false") {
							linkArr.forEach(function (link) { showAll(link, true) });
						}
						openCloseAttr = openClose.getAttribute('aria-hidden');
					});
			};

		}
		var accordions = esriClientUtils.selectAll(".faq-accordion--outer");
		accordions.forEach(function(accordion){
			new Accordion(accordion);
		});
	});
})();
document.addEventListener('DOMContentLoaded', () => {
    class ExternalLinks {
        constructor() {
            let anchors = [].slice.call(document.querySelectorAll('a[href]'));
            this.exeptionCases = ['storymaps.arcgis.com', 'storymapsdev.arcgis.com', 'storymapsstg.arcgis.com', 'uat', 'dev'];

            if (anchors && anchors.length) {
                anchors.forEach((a) => {
                    if (this.isExternal(a) && !a.hasAttribute('target')) {
                        a.setAttribute('target', '_blank');
                        a.setAttribute('rel', 'noopener');
                        a.setAttribute('aria-describedby', 'new-window');
                    }
                });
            }
        }

        isExternal(a) {
            let external = false;
            let href = a.getAttribute('href');
            href = href.toLowerCase();

            if (window.hasOwnProperty('isMultisite') && isMultisite) {
                return false;
            }

            if (href.indexOf('.pdf') > -1) { 
                external = true;
            }
            if (href.indexOf('//') > -1) {
                if (href.indexOf('esri.com') < 0 || (href.indexOf('.esri.com') > -1 && href.indexOf('www') < 0)) {
                    external = true;

                    // External Exceptions
                    this.exeptionCases.forEach(exptCase => {
                        let regexCase = RegExp(exptCase);

                        if (regexCase.test(href)) {
                            external = false;
                        }
                    })

                }
            }
            return external;
        }
    }

    new ExternalLinks();
});
/*
* there were two main reasons why we decided to go with JQuery for this functionality
* 1) This code will leave under wordpress and wordpress installation is already loading jquery
* 2) and more important, we are using the the JQuery autocomplete extension for the search input.
*    The extensions did allows to implement what we were looking for with few lines of code. And because we
*    are using some of the extension callbacks/hooks we decided it was just easier to continue to utilise jQuery.
 */
const gateway_search_filters = ($) => {
    let $searchForm = $('.n-gateway-search-form');

    $searchForm.each(function () {
        let $currSearchForm = $(this);

        $currSearchForm.submit(function (e) {
            e.preventDefault();
        });
        // support elements       
        let $searchInput = $currSearchForm.find(".n-gateway-search-control");
        let btnIcon = $currSearchForm.find('.n-gateway-search-submit');
        let inputLabel = $currSearchForm[0].querySelector('.n-gateway-search-label');
        let searchMesure = $currSearchForm[0].querySelector('.n-gateway-search-measure');
        let searchMesureTxt = searchMesure.querySelector('div');

        // see arcgis.gateway-search-redirection.js
        arcgis_search_redirection($searchInput, btnIcon, $currSearchForm);

        let authors = arcgis_object.authors.map(author => `@${author.name}`);
        let tags = arcgis_object.tags.map(tag => `#${tag.name}`);
        let isTagOrAuthor = /^(#|@)/;
        let advSearch = [];
        let newSelection = false;

        // add custom width to autocomplete using jquery
        $.widget("custom.autocomplete", $.ui.autocomplete, {
            _resizeMenu: function () {
                this.menu.element.outerWidth(500);
            }
        });

        $searchInput.autocomplete({
            source: advSearch,
            minLength: 2,
            _resizeMenu: function () {
                this.menu.element.outerWidth(500);
            }
        });

        // set data attr to true:
        $searchInput.data('autocomplete', true);

        // set or remove autocomplete
        $searchInput.keyup(function () {

            var queryTxt = jQuery(this).val();
            styleInputOnKeyUp(queryTxt);
            //only check the first character
            if (queryTxt.length < 2) {
                let isSpecialQuery = queryTxt.match(isTagOrAuthor);

                if (isSpecialQuery) {
                    advSearch = queryTxt.indexOf('#') == 0 ? tags : authors;
                    $searchInput.autocomplete({
                        source: advSearch,
                        minLength: 2,
                        select: function () {
                            newSelection = true;
                        },
                        close: function () {
                            if (newSelection) {
                                queryTxt = $searchInput.val();
                                styleInputOnKeyUp(queryTxt);
                                btnIcon.click();
                            }
                            newSelection = false;
                        },
                        _resizeMenu: function () {
                            this.menu.element.outerWidth(500);
                        }
                    });
                    $searchInput.data('autocomplete', true);
                } else {
                    let isActive = $searchInput.data('autocomplete');
                    if (isActive) {
                        $searchInput.autocomplete("destroy").data('autocomplete', false);
                    }
                }
            } else {
            }

        });


        function styleInputOnKeyUp(inputValue) {
            if (!inputLabel.hasAttribute('data-filled')) {
                inputLabel.setAttribute('data-filled', '');
            }
            if (inputValue) {
                searchMesureTxt.innerHTML = inputValue;
                searchMesure.style.width = `${searchMesureTxt.scrollWidth}px`;
            } else {
                searchMesureTxt.innerHTML = '';
                searchMesure.style.width = "0px";
            }
        }
        $searchInput.blur(function (event) {
            if (!event.target.value) {
                inputLabel.removeAttribute('data-filled');
            }
        });
    });
}

  /* dsdfsd */


document.addEventListener('DOMContentLoaded', function () {

  class TertiaryNavigation {

    constructor() {

      this.tertiaryTrigger = document.querySelector('.tertiary-nav--title');

      this.tertiaryItems = document.querySelector('.tertiary-nav-container');

      this.revealTertiaryItems(this.tertiaryTrigger, this.tertiaryItems);

    }

    revealTertiaryItems(trigger, items) {

      if (trigger && items) {

        let tTrigger = trigger;

        tTrigger.addEventListener('click', () => {

          let mnuState = items.getAttribute('aria-hidden') === 'true' ? 'false' : 'true';

          items.setAttribute('aria-hidden', `${mnuState}`);

        });

      }

    }

  }

  new TertiaryNavigation();

});
// StyleObserver looks for changes on the styles attribute of target element
// and then calls the callback function
class StyleObserver {
    constructor(target, callback) {

        if (target !== null) {
            var observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutationRecord) {
                    callback();
                });
            });
            observer.observe(target, { attributes: true, attributeFilter: ['style'] });
        }
    }
}

class TriggerMobileSocialShare {
    constructor($mobileShare, $floor) {

        this.toggleShareStickyness = this.toggleShareStickyness.bind(this);
        this.floorTarget = document.querySelector($floor);
        this.$mobileShare = $mobileShare;

        console.log('floorTarget', this.floorTarget);

        if (!this.floorTarget) {
            this.$footerObserver = this.isFooterAppended($floor, this.toggleShareStickyness);
        } else {
            this.toggleShareStickyness('noObserver');
        }
    }

    toggleShareStickyness(hasObserver) {

        console.log('toggleShareStickyness', this.floorTarget);

        if (hasObserver != 'noObserver') {
            this.$footerObserver.disconnect();
        }
        let $floorLimit = this.floorTarget;

        window.addEventListener('scroll', () => {
            if ($floorLimit && this.isAnyPartOfElementInViewport($floorLimit)) {
                if (!this.$mobileShare.classList.contains('non-sticky')) {
                    this.$mobileShare.classList.add('non-sticky');
                }
            } else {
                if (this.$mobileShare.classList.contains('non-sticky')) {
                    this.$mobileShare.classList.remove('non-sticky');
                }
            }
        })
    }

    isAnyPartOfElementInViewport(el) {

        const rect = el.getBoundingClientRect();
        // DOMRect { x: 8, y: 8, width: 100, height: 100, top: 8, right: 108, bottom: 108, left: 8 }
        const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
        const windowWidth = (window.innerWidth || document.documentElement.clientWidth);

        // http://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
        const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
        const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

        return (vertInView && horInView);
    }

    // footer is injected dynamically need to know when is appended.
    // will use MutationObserver to find out
    isFooterAppended($footerStr, $triggerCallBack) {
        var targetNode = document.querySelector('body');
        // Options for the observer (which mutations to observe)
        var config = { attributes: true, childList: true, subtree: true };

        // Callback function to execute when mutations are observed
        var callback = function (mutationsList, observer) {
            for (var mutation of mutationsList) {
                if (mutation.type == 'childList') {
                    let $globalFooter = document.querySelector($footerStr);
                    if ($globalFooter) {
                        $triggerCallBack();
                    }
                }
            }
        };

        // Create an observer instance linked to the callback function
        var observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);

        // observer.disconnect();
        return observer;

    }
}
/*!
* Clamp.js 0.5.1
*
* Copyright 2011-2013, Joseph Schmitt http://joe.sh
* Released under the WTFPL license
* http://sam.zoy.org/wtfpl/
*/

(function () {
    /**
     * Clamps a text node.
     * @param {HTMLElement} element. Element containing the text node to clamp.
     * @param {Object} options. Options to pass to the clamper.
     */
    function clamp(element, options) {
        options = options || {};

        var self = this,
            win = window,
            opt = {
                clamp: options.clamp || 2,
                useNativeClamp: typeof (options.useNativeClamp) != 'undefined' ? options.useNativeClamp : true,
                splitOnChars: options.splitOnChars || ['.', '-', '–', '—', ' '], //Split on sentences (periods), hypens, en-dashes, em-dashes, and words (spaces).
                animate: options.animate || false,
                truncationChar: options.truncationChar || '…',
                truncationHTML: options.truncationHTML
            },

            sty = element.style,
            originalText = element.innerHTML,

            supportsNativeClamp = typeof (element.style.webkitLineClamp) != 'undefined',
            clampValue = opt.clamp,
            isCSSValue = clampValue.indexOf && (clampValue.indexOf('px') > -1 || clampValue.indexOf('em') > -1),
            truncationHTMLContainer;

        if (opt.truncationHTML) {
            truncationHTMLContainer = document.createElement('span');
            truncationHTMLContainer.innerHTML = opt.truncationHTML;
        }


        // UTILITY FUNCTIONS __________________________________________________________

        /**
         * Return the current style for an element.
         * @param {HTMLElement} elem The element to compute.
         * @param {string} prop The style property.
         * @returns {number}
         */
        function computeStyle(elem, prop) {
            if (!win.getComputedStyle) {
                win.getComputedStyle = function (el, pseudo) {
                    this.el = el;
                    this.getPropertyValue = function (prop) {
                        var re = /(\-([a-z]){1})/g;
                        if (prop == 'float') prop = 'styleFloat';
                        if (re.test(prop)) {
                            prop = prop.replace(re, function () {
                                return arguments[2].toUpperCase();
                            });
                        }
                        return el.currentStyle && el.currentStyle[prop] ? el.currentStyle[prop] : null;
                    }
                    return this;
                }
            }

            return win.getComputedStyle(elem, null).getPropertyValue(prop);
        }

        /**
         * Returns the maximum number of lines of text that should be rendered based
         * on the current height of the element and the line-height of the text.
         */
        function getMaxLines(height) {
            var availHeight = height || element.clientHeight,
                lineHeight = getLineHeight(element);

            return Math.max(Math.floor(availHeight / lineHeight), 0);
        }

        /**
         * Returns the maximum height a given element should have based on the line-
         * height of the text and the given clamp value.
         */
        function getMaxHeight(clmp) {
            var lineHeight = getLineHeight(element);
            return lineHeight * clmp;
        }

        /**
         * Returns the line-height of an element as an integer.
         */
        function getLineHeight(elem) {
            var lh = computeStyle(elem, 'line-height');
            if (lh == 'normal') {
                // Normal line heights vary from browser to browser. The spec recommends
                // a value between 1.0 and 1.2 of the font size. Using 1.1 to split the diff.
                lh = parseInt(computeStyle(elem, 'font-size')) * 1.2;
            }
            return parseInt(lh);
        }


        // MEAT AND POTATOES (MMMM, POTATOES...) ______________________________________
        var splitOnChars = opt.splitOnChars.slice(0),
            splitChar = splitOnChars[0],
            chunks,
            lastChunk;

        /**
         * Gets an element's last child. That may be another node or a node's contents.
         */
        function getLastChild(elem) {
            //Current element has children, need to go deeper and get last child as a text node
            if (elem.lastChild.children && elem.lastChild.children.length > 0) {
                return getLastChild(Array.prototype.slice.call(elem.children).pop());
            }
            //This is the absolute last child, a text node, but something's wrong with it. Remove it and keep trying
            else if (!elem.lastChild || !elem.lastChild.nodeValue || elem.lastChild.nodeValue == '' || elem.lastChild.nodeValue == opt.truncationChar) {
                elem.lastChild.parentNode.removeChild(elem.lastChild);
                return getLastChild(element);
            }
            //This is the last child we want, return it
            else {
                return elem.lastChild;
            }
        }

        /**
         * Removes one character at a time from the text until its width or
         * height is beneath the passed-in max param.
         */
        function truncate(target, maxHeight) {
            if (!maxHeight) { return; }

            /**
             * Resets global variables.
             */
            function reset() {
                splitOnChars = opt.splitOnChars.slice(0);
                splitChar = splitOnChars[0];
                chunks = null;
                lastChunk = null;
            }

            var nodeValue = target.nodeValue.replace(opt.truncationChar, '');

            //Grab the next chunks
            if (!chunks) {
                //If there are more characters to try, grab the next one
                if (splitOnChars.length > 0) {
                    splitChar = splitOnChars.shift();
                }
                //No characters to chunk by. Go character-by-character
                else {
                    splitChar = '';
                }

                chunks = nodeValue.split(splitChar);
            }

            //If there are chunks left to remove, remove the last one and see if
            // the nodeValue fits.
            if (chunks.length > 1) {
                // console.log('chunks', chunks);
                lastChunk = chunks.pop();
                // console.log('lastChunk', lastChunk);
                applyEllipsis(target, chunks.join(splitChar));
            }
            //No more chunks can be removed using this character
            else {
                chunks = null;
            }

            //Insert the custom HTML before the truncation character
            if (truncationHTMLContainer) {
                target.nodeValue = target.nodeValue.replace(opt.truncationChar, '');
                element.innerHTML = target.nodeValue + ' ' + truncationHTMLContainer.innerHTML + opt.truncationChar;
            }

            //Search produced valid chunks
            if (chunks) {
                //It fits
                if (element.clientHeight <= maxHeight) {
                    //There's still more characters to try splitting on, not quite done yet
                    if (splitOnChars.length >= 0 && splitChar != '') {
                        applyEllipsis(target, chunks.join(splitChar) + splitChar + lastChunk);
                        chunks = null;
                    }
                    //Finished!
                    else {
                        return element.innerHTML;
                    }
                }
            }
            //No valid chunks produced
            else {
                //No valid chunks even when splitting by letter, time to move
                //on to the next node
                if (splitChar == '') {
                    applyEllipsis(target, '');
                    target = getLastChild(element);

                    reset();
                }
            }

            //If you get here it means still too big, let's keep truncating
            if (opt.animate) {
                setTimeout(function () {
                    truncate(target, maxHeight);
                }, opt.animate === true ? 10 : opt.animate);
            }
            else {
                return truncate(target, maxHeight);
            }
        }

        function applyEllipsis(elem, str) {
            elem.nodeValue = str + opt.truncationChar;
        }


        // CONSTRUCTOR ________________________________________________________________

        if (clampValue == 'auto') {
            clampValue = getMaxLines();
        }
        else if (isCSSValue) {
            clampValue = getMaxLines(parseInt(clampValue));
        }

        var clampedText;
        if (supportsNativeClamp && opt.useNativeClamp) {
            sty.overflow = 'hidden';
            sty.textOverflow = 'ellipsis';
            sty.webkitBoxOrient = 'vertical';
            sty.display = '-webkit-box';
            sty.webkitLineClamp = clampValue;

            if (isCSSValue) {
                sty.height = opt.clamp + 'px';
            }
        }
        else {
            var height = getMaxHeight(clampValue);
            if (height <= element.clientHeight) {
                clampedText = truncate(getLastChild(element), height);
            }
        }

        return {
            'original': originalText,
            'clamped': clampedText
        }
    }

    window.$clamp = clamp;
})();

class VideoCarousel {
	constructor(){
		this.videocarousel = document.querySelector('.video-carousel');
		if (this.videocarousel) {
			this.videoCarouselElement =  this.videocarousel.querySelector(".video-carousel_thumbnails");
			if (this.videoCarouselElement){
				const numItems = this.videoCarouselElement.querySelectorAll('.thumbnails');
				this.initilizeCarousel(numItems,this.videoCarouselElement);
				// this.resizeCarousel(numItems,this.videoCarouselElement);
				window.addEventListener('resize', () => {		
					const numItems = this.videoCarouselElement.querySelectorAll('.thumbnails');
					const viewport = this.getCurrentViewport();
					const viewPortWidth = window.innerWidth;
					const element = this.videoCarouselElement;
			
					if (viewport === 'mobile' || viewport === 'tablet') {
						let carouselwidth = Math.ceil((.82 * viewPortWidth) * numItems.length);
						element.style.width = (carouselwidth + "px");
					} else if (viewport === 'desktop') {
						element.style.width = "144px";
					}
				});
			}
		}
	}

	initilizeCarousel(thumbnails, element){
		const viewport = this.getCurrentViewport();
		const numItems = thumbnails.length;
		const viewPortWidth = window.innerWidth;

		if (viewport === 'mobile' || viewport === 'tablet') {
			let carouselwidth = Math.ceil((.82 * viewPortWidth) * numItems);
			element.style.width = (carouselwidth + "px");
		}
	}

	
getCurrentViewport() {

	const viewport = window.innerWidth;

	if (viewport >= 0 && viewport < 768) {
		return 'mobile';
 
	} else if (viewport >= 768 && viewport <= 860) {
		return 'tablet';
 
	} else {
		return 'desktop';
 
	}
				 
 }


}
new VideoCarousel();


'use strict';
var show = function (elem) {
	var clicker = document.querySelector('.toggle');
	
	// Get the natural height of the element
	var getHeight = function () {
		elem.style.display = 'block'; // Make it visible
		var height = elem.scrollHeight + 'px'; // Get it's height
		elem.style.display = ''; //  Hide it again
		return height;
	};

	var height = getHeight(); // Get the natural height
	elem.classList.add('is-visible'); // Make the element visible
	clicker.setAttribute("aria-expanded", "true");
	elem.style.height = height; // Update the max-height

	// Once the transition is complete, remove the inline max-height so the content can scale responsively
	window.setTimeout(function () {
		elem.style.height = '';
	}, 350);

};

// Hide an element
var hide = function (elem) {

	// Give the element a height to change from
	elem.style.height = elem.scrollHeight + 'px';
	var clicker = document.querySelector('.toggle');
	clicker.setAttribute("aria-expanded", "false");

	// Set the height back to 0
	window.setTimeout(function () {
		elem.style.height = '0';
	}, 1);

	// When the transition is complete, hide it
	window.setTimeout(function () {
		elem.classList.remove('is-visible');
	}, 350);
};

// Toggle element visibility
var toggle = function (elem, timing) {

	// If the element is visible, hide it
	if (elem.classList.contains('is-visible')) {
		hide(elem);
		return;
	}

	// Otherwise, show it
	show(elem);
	
};

// Listen for click events
document.addEventListener('click', function (event) {

	// Make sure clicked element is our toggle
	if (!event.target.classList.contains('toggle')) return;

	// Prevent default link behavior
	event.preventDefault();

	// Get the content
	var content = document.querySelector(event.target.hash);
	if (!content) return;

	// Toggle the content
	toggle(content);

}, false);
var CircularCarousel = {   
	start_time : 0,
	list_obj : {},
	position : "Right",
	delay: 500,
	width: 20,
	margin_left: -3,
	computed_width: 23,
	init : function(position,ul_selector,delay){
		CircularCarousel.position = position;
		CircularCarousel.delay = delay;
		var li_array = document.querySelectorAll(ul_selector + ' li');
		CircularCarousel.width = li_array[0].offsetWidth;
		CircularCarousel.computed_width = CircularCarousel.width-CircularCarousel.margin_left;
		CircularCarousel.list_obj = {li_array: li_array,selector:ul_selector};
	},
	animateCarousel : function(timestamp){
		if(!CircularCarousel.start_time){CircularCarousel.start_time = timestamp;}
		var li_array = CircularCarousel.list_obj.li_array;
		var selector = CircularCarousel.list_obj.selector;
		var progress = timestamp - CircularCarousel.start_time;
		if(CircularCarousel.position == 'Left'){
			var margin_left = Math.max(CircularCarousel.computed_width-((progress*CircularCarousel.computed_width)/CircularCarousel.delay),CircularCarousel.margin_left);
			document.querySelector(selector + ' li:first-child').style.marginLeft = (margin_left*-1).toString()+'px';
			if(margin_left == CircularCarousel.margin_left){
				f_child = document.querySelector(selector + ' li:last-child');
				f_child.parentNode.removeChild(f_child);
				CircularCarousel.start_time = 0;
				return;
			}
		}else if(CircularCarousel.position == 'Right'){
			var margin_left = Math.min(((progress*CircularCarousel.computed_width)/CircularCarousel.delay),CircularCarousel.computed_width);
			document.querySelector(selector + ' li:first-child').style.marginLeft = (margin_left*-1).toString()+'px';
			if(margin_left == CircularCarousel.computed_width){
				f_child = document.querySelector(selector + ' li:first-child');
				f_child.parentNode.removeChild(f_child);
				CircularCarousel.start_time = 0;
				return;
			}
		}
		if(progress<=(CircularCarousel.delay+20)){
			requestAnimationFrame(CircularCarousel.animateCarousel);
		}else{
			CircularCarousel.start_time = 0;
		}
	},
	cloneListNode: function(li_node){
		var li = document.createElement('li');
		li.innerHTML = li_node.innerHTML;
		li.classList = li_node.classList;
		return li;
	},
	shiftCarousel : function(position,ul_selector,delay){	
		if(!CircularCarousel.start_time){
			CircularCarousel.init(position,ul_selector,delay);
			var frag = document.createDocumentFragment();
			var li_array = CircularCarousel.list_obj.li_array;
			var selector = CircularCarousel.list_obj.selector;
			if(position == 'Left'){
				var arr_len = li_array.length;
				frag.appendChild(li_array[arr_len-1]);
				for(var i=0;i<arr_len-1;i++){
					frag.appendChild(li_array[i]);
				}
				var li = CircularCarousel.cloneListNode(li_array[arr_len-1]);
				frag.appendChild(li);
			}
			if(position == 'Right'){
				var li = CircularCarousel.cloneListNode(li_array[0]);
				frag.appendChild(li);
				for(var i=1;i<li_array.length;i++){
					frag.appendChild(li_array[i]);
				}
				frag.appendChild(li_array[0]);
			}
			document.querySelector(selector).innerHTML = "";
			document.querySelector(selector).appendChild(frag);
			if(position == 'Left'){
				document.querySelector(selector + ' li:first-child').style.marginLeft = (CircularCarousel.computed_width*-1).toString() + "px";
			}
			requestAnimationFrame(CircularCarousel.animateCarousel);
		}	
	}	
}


//For Left Click:-
var prevElm = document.getElementById('prev');
if(prevElm){
	prevElm.addEventListener("click",function(){
		  var delay = 500;  //Animation slide time in milliseconds
		  var ul_selector = '#lite-carousel ul';  //Pass the ul selector as input 
		  var position = 'Left';
		  CircularCarousel.shiftCarousel(position,ul_selector,delay);
		});
}


//For Right Click:-
var nextElm = document.getElementById('prev');
if(nextElm) {
	nextElm.addEventListener("click",function(){
		var delay = 500;  //Animation slide time in milliseconds
		var ul_selector = '#lite-carousel ul';  //Pass the ul selector as input 
		var position = 'Right';
		CircularCarousel.shiftCarousel(position,ul_selector,delay);
	  });
}





/**
 * Yaku es6 promise
 */

var Promise = Yaku;
/*
* Global functions
*
*
 */


// prevent card link from bubbling up
let preventCardLinkToBubble = () => {

	let cardSimpleLink = [].slice.call(document.querySelectorAll('.newsr-hero--simple-link'));

	cardSimpleLink.forEach(link => {
		link.addEventListener('click', e => {
			e.stopImmediatePropagation();
		})
	})
}


/* Add .remove() support for ie 11 */
(function () {
	Element.prototype.remove = function () {
		this.parentElement.removeChild(this);
	}
	NodeList.prototype.remove = HTMLCollection.prototype.remove = function () {
		for (var i = this.length - 1; i >= 0; i--) {
			git
			if (this[i] && this[i].parentElement) {
				this[i].parentElement.removeChild(this[i]);
			}
		}
	};

}());

document.addEventListener("DOMContentLoaded", function (event) {
	console.log('>>>> [test v.1.1]')

	run_view_more();

	var copyCodeButtons = [].slice.call(document.querySelectorAll('[data-action-copy-code]'));
	copyCodeButtons.forEach(function (button, i) {
		var location = button.getAttribute('data-action-copy-code');
		new Clipboard(button, {
			target: function (trigger) {
				button.setAttribute('aria-label', 'Copied!');
				button.blur();
				setTimeout(function () {
					button.setAttribute('aria-label', 'Copy to clipboard');
				}, 6000);
				if (location == 'previous')
					return trigger.previousElementSibling;
				else
					return trigger;
			}
		});
	});


	/* Autosize of textarea codesnippets */
	var snippets = fed_powers.get_arr('textarea.newsr-aside_code-block');
	for (var i = 0; i < snippets.length; i++) {
		snippets[i].style.height = 'auto';
		snippets[i].style.height = snippets[i].scrollHeight + 'px';
		snippets[i].addEventListener('keydown', function (e) {
			e.preventDefault();
		})
	}

	/* data attribute based clickable areas
	*
	* Need both a parent clickable area; add 'data-clickable-area' attribute
	* and also the child anchor tag with valid href: 'add data-dynamic-cta' attribute
	* Feel free to improve or extend.
	* v2
	 */
	(function () {
		let clickableAreas = [].slice.call(document.querySelectorAll('[data-clickable-area]'));

		if (clickableAreas) {
			clickableAreas.forEach(elm => {
				let hasURL = elm.dataset.clickableArea;

				if (hasURL) {
					tieLinkEvent(elm, hasURL);
				} else {
					let currentCta = elm.querySelector('[data-dynamic-cta]');

					let areaLink = currentCta.getAttribute('href');
					if (areaLink) {
						tieLinkEvent(elm, areaLink);
					}
				}

			})
		}

		function tieLinkEvent(target, url) {
			target.addEventListener('click', function (e) {
				e.preventDefault();
				let esriRegex = new RegExp(/esri.com/);
				if (url.search(esriRegex) == -1) {
					let $anchor = target.querySelector('[data-dynamic-cta]');
					if ($anchor) {
						simulateClick($anchor);
					} else {
						console.warn('no link inside clickable area!!!');
					}
				} else {
					location.assign(url);
				}
			})

			/**
         * Simulate a click event.
         */
			function simulateClick(elem) {
				// Create our event (with options)
				var evt = new MouseEvent('click', {
					bubbles: false,
					cancelable: true,
					view: window
				});
				// If cancelled, don't dispatch our event
				var canceled = !elem.dispatchEvent(evt);
			};
		}
	}())


	calcite.init();

	preventCardLinkToBubble();


	/**
	 * Initializes the sticky nav specific to article
	 * the bounded_sticky can be used anywhere else with out this
	 * logic, this logic is needed because we don't know what the
	 * bottom boundry section will be (is set dynamic depending on
	 * the availability of content
	 */
	if (boundedSticky) {
		if (document.querySelector('[data-sticky-boundry="bottom"]')) {
			// if the bottom bound is set just initialize sticky

			boundedSticky.initScrollWatcher({
				minTopOffset: 120, /* Sets default top offset to account for navigation as is injected dynamically */
				paddingTop: 90,
				paddingBottom: 30
			});
		} else {

			// if it is not set in some cases there is no "next article" section added the data attribute
			let bottomBound = document.querySelector('[data-sticky="target"] + *');
			bottomBound.setAttribute('data-sticky-boundry', 'bottom');

			boundedSticky.init();
			boundedSticky.initScrollWatcher({
				minTopOffset: 120, /* Sets default top offset to account for navigation as is injected dynamically */
				paddingTop: 90,
				paddingBottom: 30
			});
		};

	}

	/* needed to intercept the search function to capture and modify the query
	*  on all search boxes for arcGIS (may be needed for nextroom latter
	* */

	// step
	let resizeStep = 0;

	// if arcGIS gateway
	let isArcgisOverview = document.querySelector('.arcGis-gateway');
	let isArcgisGateWay = document.querySelector('.arcGis-product-gateway:not(.search-results)');
	let isBrowseAll = document.querySelector('.browse-all');

	var currentWindowWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;
	if (isArcgisGateWay || isArcgisOverview || isBrowseAll) {
		gateway_search_filters(jQuery);
	}

	// resize event triggered
	// check if width has a diff of +/- 100 (or desired step)
	// if it does set step to new width
	// trigger function or desired script
	// set step var to current width
	window.addEventListener("resize", function () {
		var currentWindowWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;
		if (currentWindowWidth > (resizeStep + 100) || currentWindowWidth < (resizeStep - 100)) {
			resizeStep = currentWindowWidth;
			if (currentWindowWidth > 860) {
				if (isArcgisGateWay) {
					gateway_search_filters(jQuery);
				}
			}
		}
	});

	var target = document.getElementById('pardotIFrameInArticle');
	var changingElm = document.querySelector('.iframe-wrapper');

	new StyleObserver(target, changePardotFormHeight)

	function changePardotFormHeight() {
		changingElm.style.height = `${target.offsetHeight}px`;
	}

	// mobile share toggle fix/relative state
	var $mobileShare = document.querySelector('.mobile-share');
	if ($mobileShare) {
		// first param = sticky element / social nav
		// Second param = bottom stickyness limit
		new TriggerMobileSocialShare($mobileShare, '.newsr-inb');

		$mobileShare.onclick = function () {
			animateSocialShare();
		};
	}

	function animateSocialShare() {
		var elem = document.querySelector('.mobile-share');
		elem.setAttribute('data-state', elem.getAttribute('data-state') === 'open' ? 'closed' : 'open');
	}

	//on scroll close the mobile social share



	let closeSocialShare = function () {
		let elem = document.querySelector('.mobile-share');
		setTimeout(function () {
			if (elem) {
				let state = elem.getAttribute('data-state');
				if (state == "open") {
					elem.setAttribute('data-state', 'closed');
				};
			}
		}, 200);
	};

	window.addEventListener('scroll', closeSocialShare);



	// Add clamp js to cards headings
	let cardHeadings = [].slice.call(document.querySelectorAll('.newsr-card--heading'));
	if (cardHeadings.length) {
		cardHeadings.forEach(heading => {
			if (heading.offsetHeight > 59) { //line height ~ 30 (more than two lines);
				$clamp(heading, { clamp: 2 });
			}
		});
	}

});



jQuery(function ($) {

	/**
	 * Initialize jquery onload
	 * fix issue with sticky nav staying focused after pop window was open (sticky nav)
	 */

	$('.news-share-control, .n-gateway-share-control').on('click', function (e) {
		$(this).blur();
	});

	/**
	 * preventing hardcoded width to pardot frame
	 */

	iFrameResize({ log: false, checkOrigin: false, heightCalculationMethod: 'documentElementOffset' }, '.pardotform');


}(jQuery));

// v.11.03.2021





